document.addEventListener('DOMContentLoaded', function() {
  (function() {
    'use strict';
  
    const DEBUG = window.location.search.includes('debug=true');
  
    function trapFocus(container) {
      const focusable = container.querySelectorAll('button, input, select, a[href]');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      first.focus();
      container.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }
  
    DEBUG && console.log('🔍 Initializing Meilisearch collection...');
  
    // XSS protection
    function escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  
    // Sanitize HTML: strips dangerous tags but keeps safe formatting
    function sanitizeHtml(html) {
      if (!html) return '';
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const dangerousTags = ['script', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'button'];
      dangerousTags.forEach(tag => {
        doc.querySelectorAll(tag).forEach(el => el.remove());
      });
      // Remove SVGs with event handlers
      doc.querySelectorAll('svg').forEach(el => {
        const attrs = el.attributes;
        for (let i = attrs.length - 1; i >= 0; i--) {
          if (attrs[i].name.startsWith('on')) { el.remove(); return; }
        }
      });
      // Remove event handler attributes from all remaining elements
      doc.querySelectorAll('*').forEach(el => {
        const attrs = el.attributes;
        for (let i = attrs.length - 1; i >= 0; i--) {
          if (attrs[i].name.startsWith('on')) el.removeAttribute(attrs[i].name);
        }
        // Remove javascript: URLs
        ['href', 'src', 'action'].forEach(attr => {
          const val = el.getAttribute(attr);
          if (val && val.trim().toLowerCase().startsWith('javascript:')) el.removeAttribute(attr);
        });
      });
      return doc.body.innerHTML;
    }
  
    // Price formatting helper - adds commas for thousands
    function formatPrice(price) {
      return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  
    // Image optimization helper - generates WebP URL at specified width from Shopify CDN URL
    function shopifyImageUrl(url, width) {
      if (!url) return '';
      const base = url.split('?')[0];
      const params = new URLSearchParams(url.includes('?') ? url.split('?')[1] : '');
      const v = params.get('v') || '';
      return `${base}?width=${width}&format=webp${v ? '&v=' + v : ''}`;
    }
  
    // Generate srcset string for responsive images
    function shopifyImageSrcset(url, widths) {
      if (!url) return '';
      return widths.map(w => `${escapeHtml(shopifyImageUrl(url, w))} ${w}w`).join(', ');
    }
  
    const collectionHandle = window.__COLLECTION.handle;
    const collectionTitle = window.__COLLECTION.title;
  
    // ==================== ELEVAR DATA LAYER ====================
    function getElevarUserProperties() {
      return { visitor_type: window.__st?.cid ? 'logged_in' : 'guest' };
    }
  
    function buildElevarImpression(product, index, listName) {
      return {
        id: product.sku || String(product.variant_id || product.id),
        name: product.title || '',
        brand: product.vendor || '',
        category: product['custom.product_category'] || product['custom.product_type'] || product.product_type || '',
        variant: product.variant_title || '',
        price: String(product.price || 0),
        product_id: String(product.product_id || ''),
        variant_id: String(product.variant_id || ''),
        list: listName,
        position: index + 1
      };
    }
  
    let _elevarViewItemListFired = false;
    function fireElevarViewItemList(groupedProducts) {
      if (_elevarViewItemListFired) return;
      _elevarViewItemListFired = true;
      const impressions = groupedProducts.slice(0, 50).map((group, i) =>
        buildElevarImpression(group.main, i, '/collections/' + collectionHandle)
      );
      const event = {
        event: 'dl_view_item_list',
        user_properties: getElevarUserProperties(),
        ecommerce: {
          currencyCode: 'CAD',
          impressions: impressions
        }
      };
      window.ElevarDataLayer = window.ElevarDataLayer || [];
      window.ElevarDataLayer.push(event);
      DEBUG && console.log('📊 Elevar dl_view_item_list fired:', impressions.length, 'items');
    }
  
    function fireElevarSelectItem(product, index) {
      const event = {
        event: 'dl_select_item',
        user_properties: getElevarUserProperties(),
        ecommerce: {
          currencyCode: 'CAD',
          click: {
            actionField: {
              list: '/collections/' + collectionHandle,
              action: 'click'
            },
            products: [buildElevarImpression(product, index, '/collections/' + collectionHandle)]
          }
        }
      };
      window.ElevarDataLayer = window.ElevarDataLayer || [];
      window.ElevarDataLayer.push(event);
      DEBUG && console.log('📊 Elevar dl_select_item fired:', product.title);
    }
  
    // Expose for onclick handlers in product cards
    window._elevarSelectItem = fireElevarSelectItem;
  
    // GWP promo tags for badge display
    let gwpPromoTags = [];
    fetch('https://search.bbqing.com/api/gift-with-purchase')
      .then(function(r) { return r.json(); })
      .then(function(promos) {
        gwpPromoTags = promos.filter(function(p) { return p.triggerType === 'tag'; }).map(function(p) { return p.triggerValue; });
      })
      .catch(function() {});
  
    function hasGwpPromo(tags) {
      if (!tags || !tags.length) return false;
      // Tag-based promo triggers (e.g. gwp-baron-griddle for the Broil King rule).
      if (gwpPromoTags.length && gwpPromoTags.some(function(t) { return tags.indexOf(t) !== -1; })) return true;
      // Variant-based promo triggers — products manually tagged gwp-trigger in Shopify Admin.
      // This catches the Gozney variant-trigger rules where the rule's triggerValue is a variant ID,
      // not a tag, so gwpPromoTags wouldn't include it.
      if (tags.indexOf('gwp-trigger') !== -1) return true;
      return false;
    }
  
    // One filter set for every collection. Irrelevant filters self-hide when there are 0 or 1
    // facet values, so listing them all here is safe. Per-collection-type filter sets used to
    // be driven by custom.collection_type (now deleted) — add that back when the rebuild needs it.
    const activeFilters = ['product-category', 'product-type', 'configuration', 'brand', 'fuel-type', 'price', 'series', 'main-burners', 'side-burners', 'rear-rotisserie', 'color'];
  
    // Search proxy — API key stays server-side
    const SEARCH_PROXY_BASE = 'https://search.bbqing.com/api/proxy';
    const index = {
      search: async function(q, params) {
        const body = Object.assign({}, params || {}, { q: q || '' });
        const res = await fetch(SEARCH_PROXY_BASE + '/search/shopify_content', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error('Search request failed: ' + res.status);
        return res.json();
      }
    };
  
    // ==================== MAIN COLLECTION FUNCTIONALITY ====================
  
    let allProducts = [];
    let allProductsBeforePagination = []; // Stores ALL products when boost rules are active
    let currentPage = 1;
    let productsPerPage = 100; // Display 100 products per page
    let totalEstimatedHits = 0;  // Track total results for pagination
    let facetDistribution = {};  // Store facet counts from Meilisearch
    /* Union of every facet value we've seen so far on this page, per facet key.
       Used to keep the option list from shrinking as the user checks boxes — otherwise
       Meilisearch filters out unselected values from the distribution and multi-select
       becomes impossible. Counts still come from the current filtered distribution
       (0 when a value doesn't apply under current filters). */
    let seenFacetValues = {};
    let currentFilters = { brands: new Set(), types: new Set(), colors: new Set(), fuelTypes: new Set(), priceMin: null, priceMax: null, newArrival: false, promotion: false, clearance: false, canadianBrands: false, taxonomy: { configuration: new Set() }, series: new Set(), mainBurners: new Set(), sideBurners: new Set(), rearRotisserie: new Set(), metafields: {}, productCategory: new Set(), productType: new Set(), configuration: new Set(), availability: new Set() };
    let currentSort = 'relevance';
    let userChangedSort = false; // Track if user explicitly changed sort (vs global default)
    let compareProducts = new Set(JSON.parse(localStorage.getItem('compareProducts') || '[]'));
    const MAX_COMPARE = 4;
    let boostRules = [];
    let sortingRules = { global: null, specific: [] };
    let collectionRule = null;
  
    // Filter configuration (loaded from dashboard for color families)
    let filterConfig = null;
    let COLOR_FAMILIES = {};
  
    // Load filter configuration from dashboard API (for color families)
    async function loadFilterConfig() {
      try {
        const response = await fetch('https://search.bbqing.com/api/filter-config');
        filterConfig = await response.json();
        COLOR_FAMILIES = filterConfig.colorFamilies || {};
        window.filterConfig = filterConfig;
        renderFilterSections();
        DEBUG && console.log('✅ Filter configuration loaded from dashboard');
      } catch (error) {
        DEBUG && console.error('⚠️ Error loading filter config:', error);
        COLOR_FAMILIES = {};
        renderFilterSections();
      }
    }
  
    // Render dropdown filter sections in fixed order
    function renderFilterSections() {
      const container = document.getElementById('dynamic-filters-container');
      if (!container) return;
  
      const dropdownFilter = (id, label) => `
        <div style="margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid #e7e7e7;">
          <h4 onclick="toggleFilterSection('${id}')" style="font-size: 13px; font-weight: 600; margin-bottom: 12px; color: #1a1a1a; cursor: pointer; display: flex; justify-content: space-between; align-items: center; user-select: none;">
            <span>${label}</span>
            <svg id="${id}-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" style="transition: transform 0.2s;">
              <path d="M3 5l3 3 3-3"/>
            </svg>
          </h4>
          <div id="${id}-filter-options" style="display: none;"></div>
        </div>
      `;
  
      const priceFilter = `<div style="margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #e7e7e7;">
          <h4 style="font-size: 13px; font-weight: 600; margin-bottom: 12px; color: #1a1a1a;">Price</h4>
          <div style="display: grid; grid-template-columns: 1fr auto 1fr; gap: 8px; align-items: center; margin-bottom: 16px;">
            <input type="number" id="price-min" placeholder="$0" min="0" style="padding: 10px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 13px; width: 100%; box-sizing: border-box; background: white; transition: border-color 0.2s;" onfocus="this.style.borderColor='#1a1a1a'; this.style.outline='none'" onblur="this.style.borderColor='#e5e7eb'">
            <span style="color: #d1d5db;">–</span>
            <input type="number" id="price-max" placeholder="$9,999" min="0" style="padding: 10px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 13px; width: 100%; box-sizing: border-box; background: white; transition: border-color 0.2s;" onfocus="this.style.borderColor='#1a1a1a'; this.style.outline='none'" onblur="this.style.borderColor='#e5e7eb'">
          </div>
          <div style="position: relative; height: 6px; background: #e5e7eb; border-radius: 3px; margin-bottom: 8px;">
            <div id="price-slider-range" style="position: absolute; height: 100%; background: #1a1a1a; border-radius: 3px; left: 0; right: 0;"></div>
            <input type="range" id="price-slider-min" min="0" max="10000" value="0" step="10" style="position: absolute; width: 100%; height: 6px; -webkit-appearance: none; appearance: none; background: transparent; pointer-events: none; margin: 0;">
            <input type="range" id="price-slider-max" min="0" max="10000" value="10000" step="10" style="position: absolute; width: 100%; height: 6px; -webkit-appearance: none; appearance: none; background: transparent; pointer-events: none; margin: 0;">
          </div>
        </div>`;
  
      const colorFilter = `<div style="margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid #e7e7e7;">
          <h4 onclick="toggleFilterSection('color')" style="font-size: 13px; font-weight: 600; margin-bottom: 12px; color: #1a1a1a; cursor: pointer; display: flex; justify-content: space-between; align-items: center; user-select: none;">
            <span>Color</span>
            <svg id="color-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" style="transition: transform 0.2s;">
              <path d="M3 5l3 3 3-3"/>
            </svg>
          </h4>
          <div id="color-filter-options" style="display: none;"></div>
        </div>`;
  
      const filterMap = {
        'product-category': dropdownFilter('product-category', 'Product Category'),
        'product-type': dropdownFilter('product-type', 'Product Type'),
        'configuration': dropdownFilter('configuration', 'Configuration'),
        'brand': dropdownFilter('brand', 'Brand'),
        'fuel-type': dropdownFilter('fuel-type', 'Fuel Type'),
        'price': priceFilter,
        'series': dropdownFilter('series', 'Series'),
        'main-burners': dropdownFilter('main-burners', 'Main Burners'),
        'side-burners': dropdownFilter('side-burners', 'Side Burners'),
        'rear-rotisserie': dropdownFilter('rear-rotisserie', 'Rear/Rotisserie Burner'),
        'color': colorFilter,
        'availability': dropdownFilter('availability', 'Availability')
      };
  
      // "Current Offers" block — matches dropdown filter pattern, prepended above all other filters (hidden until populated)
      const offersBlock = `
        <div id="current-offers-block" style="margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid #e7e7e7; display: none;">
          <h4 onclick="toggleFilterSection('current-offers')" style="font-size: 13px; font-weight: 600; margin-bottom: 12px; color: #1a1a1a; cursor: pointer; display: flex; justify-content: space-between; align-items: center; user-select: none;">
            <span>Current Offers</span>
            <svg id="current-offers-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" style="transition: transform 0.2s; transform: rotate(180deg);">
              <path d="M3 5l3 3 3-3"/>
            </svg>
          </h4>
          <div id="current-offers-filter-options" style="display: block;"></div>
        </div>
      `;

      container.innerHTML = offersBlock + activeFilters.map(f => filterMap[f] || '').join('');
  
      refreshDynamicEls();
      initPriceSliders();
      DEBUG && console.log('🔧 Rendered filter sections');
    }
  
    // Initialize price slider event listeners
    function initPriceSliders() {
      const priceMin = document.getElementById('price-min');
      const priceMax = document.getElementById('price-max');
      const sliderMin = document.getElementById('price-slider-min');
      const sliderMax = document.getElementById('price-slider-max');
  
      if (!priceMin || !priceMax || !sliderMin || !sliderMax) {
        DEBUG && console.log('💰 [PRICE DEBUG] initPriceSliders — elements not found!');
        return;
      }
      DEBUG && console.log('💰 [PRICE DEBUG] initPriceSliders — elements found, updating refs');
  
      // Update element references
      els.priceMin = priceMin;
      els.priceMax = priceMax;
      els.priceSliderMin = sliderMin;
      els.priceSliderMax = sliderMax;
      els.priceSliderRange = document.getElementById('price-slider-range');
  
      // Attach event listeners (only once)
      attachPriceSliderListeners();
    }
  
    // Get all matching color families for a color (supports split colors like "Black/Stainless Steel")
    function getColorFamilies(color) {
      if (!color) return [];
      const colorLower = color.toLowerCase().trim();
      const matched = [];
      for (const [family, variants] of Object.entries(COLOR_FAMILIES)) {
        if (variants.some(v => colorLower.includes(v) || v.includes(colorLower))) {
          matched.push(family);
        }
      }
      return matched.length > 0 ? matched : [color]; // Return original if no family match
    }
  
    // Fetch applicable boost rules for this collection page
    async function fetchBoostRules() {
      try {
        const response = await fetch('https://search.bbqing.com/api/boost-rules/applicable', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ collectionHandle: collectionHandle })
        });
        const data = await response.json();
        boostRules = data.rules || [];
        DEBUG && console.log('📊 Loaded boost rules for collection:', collectionHandle, '→', boostRules.length, 'rules');
      } catch (error) {
        DEBUG && console.error('Error fetching boost rules:', error);
        boostRules = [];
      }
    }
  
    // Fetch multi-tier collection rule for this specific collection
    async function fetchCollectionRule() {
      try {
        const response = await fetch('https://search.bbqing.com/api/collection-rules/' + encodeURIComponent(collectionHandle));
        const data = await response.json();
        collectionRule = data.rule || null;
      } catch (error) {
        collectionRule = null;
      }
    }
  
    // Fetch sorting rules from dashboard
    async function fetchSortingRules() {
      try {
        const response = await fetch('https://search.bbqing.com/api/boost-rules');
        const data = await response.json();
        DEBUG && console.log('🔀 Full boost-rules API response:', data);
        sortingRules = data.collectionSortingRules || { global: null, specific: [] };
        DEBUG && console.log('🔀 Extracted sorting rules:', sortingRules);
        DEBUG && console.log('🔀 Global sort from API:', sortingRules.global);
      } catch (error) {
        DEBUG && console.error('Error fetching sorting rules:', error);
        sortingRules = { global: null, specific: [] };
      }
    }
  
    // Get the default sort order for this collection
    function getDefaultSort() {
      let defaultSort = 'relevance';
  
      // New multi-tier collection rule takes priority over old single-sort system
      if (collectionRule && collectionRule.primary) {
        DEBUG && console.log('📐 Multi-tier rule present — bypassing old sort defaults');
        return 'relevance';
      }
  
      // Check if there's a collection-specific rule (old single-sort system)
      const specificRule = sortingRules.specific.find(r => r.collectionHandle === collectionHandle);
      if (specificRule) {
        DEBUG && console.log('🎯 Using collection-specific sort:', specificRule.sortOrder);
        defaultSort = specificRule.sortOrder;
      }
      // Check if there's a global default sort
      else if (sortingRules.global) {
        DEBUG && console.log('🌍 Using global default sort:', sortingRules.global);
        defaultSort = sortingRules.global;
      }
  
      // Map Meilisearch format to select dropdown format
      const sortMap = {
        'price:asc': 'price-asc',
        'price:desc': 'price-desc',
        'inventory_quantity:desc': 'inventory-desc',
        'inventory_quantity:asc': 'inventory-asc',
        'created_at:desc': 'newest',
        'created_at:asc': 'oldest',
        // Manual-sort collections display as "Featured" in the dropdown — the reorder gate
        // in performSearch() triggers on both 'manual' and 'relevance', so behavior is identical
        // and the dropdown stays in sync with its actual options.
        'manual': 'relevance'
      };

      return sortMap[defaultSort] || defaultSort;
    }

    // True when the dashboard's per-collection sort rule says "manual" for this collection.
    // Used to gate the reorder step below.
    function isManualSortCollection() {
      const specificRule = sortingRules.specific.find(r => r.collectionHandle === collectionHandle);
      return specificRule && specificRule.sortOrder === 'manual';
    }

    // Reorders products by the position recorded in Meilisearch's `collection_positions` field
    // (synced from Shopify Admin API's MANUAL sort order, no Liquid 50-product cap).
    // Products without a position sink to the bottom in their current relative order.
    function reorderByManual(products) {
      const known = [];
      const unknown = [];
      products.forEach(p => {
        const pos = p.collection_positions && p.collection_positions[collectionHandle];
        if (typeof pos === 'number') known.push({ p, pos });
        else unknown.push(p);
      });
      known.sort((a, b) => a.pos - b.pos);
      return known.map(x => x.p).concat(unknown);
    }
  
    // Calculate boosted score for a product based on active rules
    function calculateBoostScore(product, debugFirst3 = false) {
      let baseScore = product.ranking_score || 100;
      let additionalBoost = 0;
  
      // Debug: Show tags for first 3 products
      if (debugFirst3) {
        DEBUG && console.log(`🏷️ Product "${product.title}" tags:`, product.tags);
      }
  
      boostRules.forEach((rule, index) => {
        let matches = false;
  
        if (rule.boostType === 'collection') {
          matches = product.collections && product.collections.includes(rule.boostValue);
        } else if (rule.boostType === 'tag') {
          matches = product.tags && product.tags.includes(rule.boostValue);
  
          // Debug: Log tag matching for first 3 products
          if (debugFirst3) {
            DEBUG && console.log(`  🔍 Looking for tag "${rule.boostValue}":`, matches ? '✅ MATCH' : '❌ no match');
          }
        } else if (rule.boostType === 'vendor') {
          matches = product.vendor === rule.boostValue;
        } else if (rule.boostType === 'product') {
          matches = product.product_id === rule.boostValue;
        }
  
        if (matches && rule.boost > additionalBoost) {
          additionalBoost = rule.boost;
        }
      });
  
      return baseScore + additionalBoost;
    }
  
    // Search sequence counter for race condition guard (must be before first performSearch call)
    let _searchSeq = 0;
  
    const els = {
      loading: document.getElementById('collection-loading'),
      noResults: document.getElementById('no-results'),
      resultsGrid: document.getElementById('collection-results-grid'),
      resultsHeader: document.getElementById('results-header'),
      resultsCount: document.getElementById('results-count'),
      // These are populated dynamically after renderFilterSections()
      brandOptions: null,
      typeOptions: null,
      colorOptions: null,
      priceMin: null,
      priceMax: null,
      priceSliderMin: null,
      priceSliderMax: null,
      priceSliderRange: null,
      // Static elements
      newArrivalToggle: document.getElementById('filter-new-arrival'),
      promotionToggle: document.getElementById('filter-promotion'),
      clearanceToggle: document.getElementById('filter-clearance'),
      canadianBrandsToggle: document.getElementById('filter-canadian-brands'),
      sortSelect: document.getElementById('sort-select'),
      clearAll: document.getElementById('clear-all-filters'),
      activeFilters: document.getElementById('active-filters')
    };
  
    // Refresh dynamic element references after filters are rendered
    function refreshDynamicEls() {
      els.brandOptions = document.getElementById('brand-filter-options');
      els.typeOptions = document.getElementById('type-filter-options');
      els.colorOptions = document.getElementById('color-filter-options');
      els.fuelTypeOptions = document.getElementById('fuel-type-filter-options');
      els.configurationOptions = document.getElementById('taxonomy-configuration-filter-options');
      els.seriesOptions = document.getElementById('series-filter-options');
      els.mainBurnersOptions = document.getElementById('main-burners-filter-options');
      els.sideBurnersOptions = document.getElementById('side-burners-filter-options');
      els.rearRotisserieOptions = document.getElementById('rear-rotisserie-filter-options');
      els.productCategoryOptions = document.getElementById('product-category-filter-options');
      els.productTypeOptions = document.getElementById('product-type-filter-options');
      els.configurationNewOptions = document.getElementById('configuration-filter-options');
      els.availabilityOptions = document.getElementById('availability-filter-options');
      els.priceMin = document.getElementById('price-min');
      els.priceMax = document.getElementById('price-max');
      els.priceSliderMin = document.getElementById('price-slider-min');
      els.priceSliderMax = document.getElementById('price-slider-max');
      els.priceSliderRange = document.getElementById('price-slider-range');
    }
  
    // Initialize from URL parameters and fetch rules
    initFromURL();

    // PERFORMANCE OPTIMIZATION: Show initial results immediately, then apply boost rules
    // This provides instant visual feedback while boost/sorting rules load in background
    let initialSearchDone = false;
    let rulesLoaded = false;

    // Wait for rules to load before first render — prevents jarring re-sort flash
    DEBUG && console.log('⏳ Loading rules before initial search...');
    const rulesPromise = Promise.all([fetchBoostRules(), fetchSortingRules(), fetchCollectionRule(), loadFilterConfig()]);

    rulesPromise.then(() => {
      rulesLoaded = true;

      // Apply default sort if no sort parameter in URL
      const params = new URLSearchParams(window.location.search);
      if (!params.has('sort')) {
        const defaultSort = getDefaultSort();
        if (defaultSort !== 'relevance') {
          currentSort = defaultSort;
          if (els.sortSelect) els.sortSelect.value = defaultSort;
        }
        // If collectionRule.primary is set, the sort-building logic in performSearch will use it
      }

      // Single search with all rules already loaded
      DEBUG && console.log('🚀 Running search with rules applied');
      performSearch().then(() => {
        initialSearchDone = true;
        DEBUG && console.log('✅ Results displayed');
      });
    });
  
    function initFromURL() {
      const params = new URLSearchParams(window.location.search);
      if (params.has('brands')) params.get('brands').split(',').forEach(b => currentFilters.brands.add(b));
      if (params.has('types')) params.get('types').split(',').forEach(t => currentFilters.types.add(t));
      if (params.has('colors')) params.get('colors').split(',').forEach(c => currentFilters.colors.add(c));
      if (params.has('fuel_types')) params.get('fuel_types').split(',').forEach(f => currentFilters.fuelTypes.add(f));
      if (params.has('configuration')) params.get('configuration').split(',').forEach(c => currentFilters.taxonomy.configuration.add(c));
      if (params.has('grill_configuration')) params.get('grill_configuration').split(',').forEach(c => currentFilters.configuration.add(c));
      if (params.has('product_category')) params.get('product_category').split(',').forEach(c => currentFilters.productCategory.add(c));
      if (params.has('product_type')) params.get('product_type').split(',').forEach(t => currentFilters.productType.add(t));
      if (params.has('availability')) params.get('availability').split(',').forEach(a => currentFilters.availability.add(a));
      if (params.has('series')) params.get('series').split(',').forEach(s => currentFilters.series.add(s));
      if (params.has('main_burners')) params.get('main_burners').split(',').forEach(b => currentFilters.mainBurners.add(b));
      if (params.has('side_burners')) params.get('side_burners').split(',').forEach(b => currentFilters.sideBurners.add(b));
      if (params.has('rear_rotisserie')) params.get('rear_rotisserie').split(',').forEach(b => currentFilters.rearRotisserie.add(b));
      if (params.has('price_min')) currentFilters.priceMin = parseFloat(params.get('price_min'));
      if (params.has('price_max')) currentFilters.priceMax = parseFloat(params.get('price_max'));
      if (params.has('new_arrival')) currentFilters.newArrival = true;
      if (params.has('promotion')) currentFilters.promotion = true;
      if (params.has('clearance')) currentFilters.clearance = true;
      if (params.has('canadian_brands')) currentFilters.canadianBrands = true;
      // Metafield filters — URL uses "mf_<key>" prefix so multiple metafield filters can co-exist.
      // Example: ?mf_custom.sale_offer_name=Summer%2520Sale,Fall%2520Blowout
      // Each value is individually URI-encoded before being joined by "," so values that
      // themselves contain commas (e.g. "Summer, End Sept 1") don't collide with the delimiter.
      for (const [key, val] of params.entries()) {
        if (!key.startsWith('mf_') || key.length <= 3) continue;
        const mfKey = key.slice(3);
        if (!currentFilters.metafields[mfKey]) currentFilters.metafields[mfKey] = new Set();
        val.split(',').forEach(v => {
          if (!v) return;
          let decoded = v;
          try { decoded = decodeURIComponent(v); } catch (_) { /* leave raw if malformed */ }
          currentFilters.metafields[mfKey].add(decoded);
        });
      }
      if (params.has('sort')) {
        currentSort = params.get('sort');
        userChangedSort = true; // URL had sort param = user explicitly chose this
      }
    }
  
    function syncToURL() {
      const params = new URLSearchParams();
      if (currentFilters.brands.size > 0) params.set('brands', Array.from(currentFilters.brands).join(','));
      if (currentFilters.types.size > 0) params.set('types', Array.from(currentFilters.types).join(','));
      if (currentFilters.colors.size > 0) params.set('colors', Array.from(currentFilters.colors).join(','));
      if (currentFilters.fuelTypes.size > 0) params.set('fuel_types', Array.from(currentFilters.fuelTypes).join(','));
      if (currentFilters.taxonomy.configuration.size > 0) params.set('configuration', Array.from(currentFilters.taxonomy.configuration).join(','));
      if (currentFilters.configuration.size > 0) params.set('grill_configuration', Array.from(currentFilters.configuration).join(','));
      if (currentFilters.productCategory.size > 0) params.set('product_category', Array.from(currentFilters.productCategory).join(','));
      if (currentFilters.productType.size > 0) params.set('product_type', Array.from(currentFilters.productType).join(','));
      if (currentFilters.availability.size > 0) params.set('availability', Array.from(currentFilters.availability).join(','));
      if (currentFilters.series.size > 0) params.set('series', Array.from(currentFilters.series).join(','));
      if (currentFilters.mainBurners.size > 0) params.set('main_burners', Array.from(currentFilters.mainBurners).join(','));
      if (currentFilters.sideBurners.size > 0) params.set('side_burners', Array.from(currentFilters.sideBurners).join(','));
      if (currentFilters.rearRotisserie.size > 0) params.set('rear_rotisserie', Array.from(currentFilters.rearRotisserie).join(','));
      if (currentFilters.priceMin) params.set('price_min', currentFilters.priceMin);
      if (currentFilters.priceMax) params.set('price_max', currentFilters.priceMax);
      if (currentFilters.newArrival) params.set('new_arrival', '1');
      if (currentFilters.promotion) params.set('promotion', '1');
      if (currentFilters.clearance) params.set('clearance', '1');
      if (currentFilters.canadianBrands) params.set('canadian_brands', '1');
      // Metafield filters — serialized as "mf_<key>=v1,v2" so any metafield facet
      // (Current Offers = custom.sale_offer_name, and others) is shareable via URL.
      // Each value is encodeURIComponent'd so commas inside a value (e.g. "Summer, End Sept 1")
      // don't collide with the delimiter — the read side decodes each entry after splitting.
      Object.entries(currentFilters.metafields).forEach(([mfKey, values]) => {
        if (values && values.size > 0) {
          const encoded = Array.from(values).map(v => encodeURIComponent(v)).join(',');
          params.set('mf_' + mfKey, encoded);
        }
      });
      // Only add sort to URL if user explicitly changed it (not from global default)
      if (userChangedSort && currentSort !== 'relevance') params.set('sort', currentSort);
  
      const newURL = params.toString() ? `${window.location.pathname}?${params.toString()}` : window.location.pathname;
      window.history.replaceState({}, '', newURL);
    }
  
    async function performSearch(loadMore = false, skipLoading = false) {
      const seq = ++_searchSeq;
      DEBUG && console.log(`🔎 [SEARCH #${seq}] Searching collection:`, collectionHandle, '| loadMore:', loadMore, '| skipLoading:', skipLoading);
      if (!loadMore && !skipLoading) {
        showLoading();
        currentPage = 1;
      } else if (!loadMore) {
        // Reset page but don't clear grid (smooth re-search)
        currentPage = 1;
      }
  
      try {
        // Build filters - filter by collection
        const filters = [
          'content_type = product',
          `collections = "${collectionHandle}"` // Filter products by this collection
        ];
        filters.splice(1, 0, 'status = "active"');

        // Checkbox filters
        if (currentFilters.newArrival) {
          filters.push('season_code = "2026"');
        }
        // Promotion = has compare_at_price + price does NOT end in .97
        // Clearance = has compare_at_price + price ends in .97
        if (currentFilters.clearance) filters.push('on_sale = true');
        if (currentFilters.promotion && !currentFilters.clearance) {
          // Include on_sale products, GWP promo tags, gwp-trigger tag, and offer_type = Promotions
          const orClauses = ['on_sale = true', 'custom.offer_type = "Promotions"', 'tags = "gwp-trigger"'];
          if (gwpPromoTags.length > 0) {
            gwpPromoTags.forEach(t => orClauses.push(`tags = "${t}"`));
          }
          filters.push(`(${orClauses.join(' OR ')})`);
        }
        if (currentFilters.canadianBrands) filters.push('tags = "Canadian Brand"');
  
        // Dropdown filters
        if (currentFilters.brands.size > 0) filters.push(`(${Array.from(currentFilters.brands).map(b => `vendor = "${b}"`).join(' OR ')})`);
        if (currentFilters.taxonomy.configuration.size > 0) filters.push(`(${Array.from(currentFilters.taxonomy.configuration).map(c => `taxonomy_configuration = "${c}"`).join(' OR ')})`);
        if (currentFilters.fuelTypes.size > 0) filters.push(`(${Array.from(currentFilters.fuelTypes).map(f => `fuel_type = "${f}"`).join(' OR ')})`);
        if (currentFilters.types.size > 0) filters.push(`(${Array.from(currentFilters.types).map(t => `taxonomy_category = "${t}"`).join(' OR ')})`);
        if (currentFilters.priceMin !== null && currentFilters.priceMin > 0) filters.push(`price >= ${currentFilters.priceMin}`);
        if (currentFilters.priceMax !== null && currentFilters.priceMax > 0) filters.push(`price <= ${currentFilters.priceMax}`);
        DEBUG && console.log('💰 [PRICE DEBUG] Filter state → priceMin:', currentFilters.priceMin, 'priceMax:', currentFilters.priceMax);
        DEBUG && console.log('💰 [PRICE DEBUG] Full filter string:', filters.join(' AND '));
        if (currentFilters.series.size > 0) filters.push(`(${Array.from(currentFilters.series).map(s => `"general_specs.series" = "${s}"`).join(' OR ')})`);
        if (currentFilters.mainBurners.size > 0) filters.push(`(${Array.from(currentFilters.mainBurners).map(m => `"bbq_specs.main_burner_count" = "${m}"`).join(' OR ')})`);
        if (currentFilters.sideBurners.size > 0) filters.push(`(${Array.from(currentFilters.sideBurners).map(s => `"bbq_specs.side_burner_included" = "${s}"`).join(' OR ')})`);
        if (currentFilters.rearRotisserie.size > 0) {
          const rrConditions = Array.from(currentFilters.rearRotisserie).flatMap(v => [`"bbq_specs.rotisserie_included" = "${v}"`, `"bbq_specs.rear_burner_included" = "${v}"`]);
          filters.push(`(${rrConditions.join(' OR ')})`);
        }
        if (currentFilters.productCategory.size > 0) filters.push(`(${Array.from(currentFilters.productCategory).map(c => `"custom.product_category" = "${c}"`).join(' OR ')})`);
        if (currentFilters.productType.size > 0) filters.push(`(${Array.from(currentFilters.productType).map(t => `"custom.product_type_v2" = "${t}"`).join(' OR ')})`);
        if (currentFilters.configuration.size > 0) filters.push(`(${Array.from(currentFilters.configuration).map(c => `"custom.grill_configuration" = "${c}"`).join(' OR ')})`);
        if (currentFilters.availability.size > 0) filters.push(`(${Array.from(currentFilters.availability).map(a => `"custom.availability_faceted_navigation" = "${a}"`).join(' OR ')})`);
  
        // Color family filtering
        if (currentFilters.colors.size > 0) {
          const colorConditions = [];
          Array.from(currentFilters.colors).forEach(family => {
            const familyVariants = COLOR_FAMILIES[family];
            if (familyVariants && familyVariants.length > 0) {
              familyVariants.forEach(variant => colorConditions.push(`color = "${variant}"`));
            } else {
              colorConditions.push(`color = "${family}"`);
            }
          });
          if (colorConditions.length > 0) filters.push(`(${colorConditions.join(' OR ')})`);
        }
  
        // Metafield filters
        Object.entries(currentFilters.metafields).forEach(([metafieldKey, values]) => {
          if (values && values.size > 0) {
            const conditions = Array.from(values).map(v => `"${metafieldKey}" = "${v}"`);
            filters.push(`(${conditions.join(' OR ')})`);
          }
        });
  
        let sort = [];
        if (currentSort === 'price-asc') sort = ['price:asc'];
        else if (currentSort === 'price-desc') sort = ['price:desc'];
        else if (currentSort === 'inventory-desc') sort = ['inventory_quantity:desc'];
        else if (currentSort === 'inventory-asc') sort = ['inventory_quantity:asc'];
        else if (currentSort === 'newest') sort = ['created_at:desc'];
        else if (currentSort === 'oldest') sort = ['created_at:asc'];
        // Handle Meilisearch format directly (from sorting rules)
        else if (currentSort.includes(':')) sort = [currentSort];
        // Multi-tier collection rule (applies when using default/relevance sort)
        else if (collectionRule) {
          if (collectionRule.primary) sort.push(collectionRule.primary);
          if (collectionRule.secondary) sort.push(collectionRule.secondary);
          if (collectionRule.tertiary) sort.push(collectionRule.tertiary);
        }
  
        // STEP 1: If boost rules exist OR promotion/clearance post-filter is active,
        // fetch ALL products first to ensure accurate results and counts
        let allMatchingProducts = [];
        const manualSortActive = isManualSortCollection() && (currentSort === 'manual' || currentSort === 'relevance');
        const needsFullFetch = (boostRules.length > 0 || currentFilters.promotion || currentFilters.clearance || manualSortActive) && !loadMore;
  
        if (needsFullFetch) {
          DEBUG && console.log('🎯 Full fetch needed (boost rules or promotion/clearance post-filter) - fetching ALL products');
  
          // Build facets array for filter counts
          const baseFacets = ['vendor', 'product_type', 'color', 'on_sale', 'tags', 'season_code', 'general_specs.series', 'bbq_specs.main_burner_count', 'bbq_specs.side_burner_included', 'bbq_specs.rotisserie_included', 'bbq_specs.rear_burner_included', 'custom.product_category', 'custom.product_type', 'custom.product_type_v2', 'custom.filter_by_style', 'custom.grill_configuration', 'custom.availability_faceted_navigation', 'custom.sale_offer_name', 'fuel_type', 'taxonomy_category', 'taxonomy_configuration'];
          const metafieldFacets = (filterConfig?.metafieldFilters || [])
            .map(f => f?.filterKey)
            .filter(key => key && !key.startsWith('accentuate.') && !key.startsWith('general_specs.') && !key.startsWith('bbq_specs.'));
          const allFacets = [...baseFacets, ...metafieldFacets];
  
          // First query to get total count and facets
          const countResponse = await index.search('', {
            filter: filters.join(' AND '),
            limit: 0,
            facets: allFacets
          });
  
          // Store facet distribution for filter counts
          if (countResponse.facetDistribution) {
            facetDistribution = countResponse.facetDistribution;
            Object.entries(countResponse.facetDistribution).forEach(([k, dist]) => {
              if (!seenFacetValues[k]) seenFacetValues[k] = new Set();
              Object.keys(dist || {}).forEach(v => seenFacetValues[k].add(v));
            });
          }
  
          const totalProducts = countResponse.estimatedTotalHits || countResponse.nbHits || 0;
          DEBUG && console.log(`📊 Total products matching filters: ${totalProducts}`);
  
          // Fetch ALL products (up to 10,000 - Meilisearch limit)
          const fetchLimit = Math.min(totalProducts, 10000);
  
          if (fetchLimit > 0) {
            const fullResponse = await index.search('', {
              filter: filters.join(' AND '),
              sort: sort.length > 0 ? sort : ['ranking_score:desc'],
              limit: fetchLimit,
              offset: 0
            });
  
            allMatchingProducts = fullResponse.hits;
            totalEstimatedHits = totalProducts;
            DEBUG && console.log(`✅ [SEARCH #${seq}] Fetched all ${allMatchingProducts.length} products for processing`);
          }
  
          // Race condition guard after full-fetch awaits
          if (seq !== _searchSeq) {
            DEBUG && console.log(`⏭️ [SEARCH #${seq}] Discarding — superseded by search #${_searchSeq}`);
            return;
          }
        } else {
          // Normal pagination when no boost rules or when loading more
          // Build facets array including any metafield filters from config
          const baseFacets = ['vendor', 'product_type', 'color', 'on_sale', 'tags', 'season_code', 'general_specs.series', 'bbq_specs.main_burner_count', 'bbq_specs.side_burner_included', 'bbq_specs.rotisserie_included', 'bbq_specs.rear_burner_included', 'custom.product_category', 'custom.product_type', 'custom.product_type_v2', 'custom.filter_by_style', 'custom.grill_configuration', 'custom.availability_faceted_navigation', 'custom.sale_offer_name', 'fuel_type', 'taxonomy_category', 'taxonomy_configuration'];
          const metafieldFacets = (filterConfig?.metafieldFilters || [])
            .map(f => f?.filterKey)
            .filter(key => key && !key.startsWith('accentuate.') && !key.startsWith('general_specs.') && !key.startsWith('bbq_specs.')); // Filter out null/undefined values
          const allFacets = [...baseFacets, ...metafieldFacets];
  
          const response = await index.search('', {
            filter: filters.join(' AND '),
            sort: sort.length > 0 ? sort : ['ranking_score:desc'],
            limit: productsPerPage,
            offset: loadMore ? currentPage * productsPerPage : 0,
            facets: allFacets
          });
  
          // Store facet distribution for accurate filter counts
          if (response.facetDistribution) {
            facetDistribution = response.facetDistribution;
            // Union every seen value into the session cache so multi-select stays available
            Object.entries(response.facetDistribution).forEach(([k, dist]) => {
              if (!seenFacetValues[k]) seenFacetValues[k] = new Set();
              Object.keys(dist || {}).forEach(v => seenFacetValues[k].add(v));
            });
            DEBUG && console.log('📊 Facet distribution keys:', Object.keys(facetDistribution));
            DEBUG && console.log('📊 Facet vendor entries:', Object.keys(facetDistribution.vendor || {}).length);
            DEBUG && console.log('📊 Facet taxonomy_category entries:', Object.keys(facetDistribution.taxonomy_category || {}).length);
            DEBUG && console.log('📊 Facet fuel_type entries:', Object.keys(facetDistribution.fuel_type || {}).length);
            DEBUG && console.log('📊 Facet taxonomy_configuration entries:', Object.keys(facetDistribution.taxonomy_configuration || {}).length);
            DEBUG && console.log('🏷️ Facet tags values:', Object.keys(facetDistribution.tags || {}));
          }
          totalEstimatedHits = response.estimatedTotalHits || response.hits.length;
  
          if (loadMore) {
            // Append new products to existing list
            allMatchingProducts = [...allProducts, ...response.hits];
          } else {
            allMatchingProducts = response.hits;
          }
          DEBUG && console.log(`✅ [SEARCH #${seq}] Collection results:`, response.hits.length, 'of', totalEstimatedHits);
        }
  
        // Race condition guard: if a newer search started while we were awaiting, discard this result
        if (seq !== _searchSeq) {
          DEBUG && console.log(`⏭️ [SEARCH #${seq}] Discarding — superseded by search #${_searchSeq}`);
          return;
        }
  
        let products = allMatchingProducts;

        // Post-filter for Clearance (.97 ending) and Promotion (non-.97 ending + GWP promos)
        if (currentFilters.clearance && !currentFilters.promotion) {
          products = products.filter(p => p.compare_at_price > 0 && Math.round(p.price * 100) % 100 === 97);
        } else if (currentFilters.promotion && !currentFilters.clearance) {
          products = products.filter(p => (p.compare_at_price > 0 && Math.round(p.price * 100) % 100 !== 97) || hasGwpPromo(p.tags) || p['custom.offer_type'] === 'Promotions');
        } else if (currentFilters.clearance && currentFilters.promotion) {
          products = products.filter(p => p.compare_at_price > 0 || hasGwpPromo(p.tags) || p['custom.offer_type'] === 'Promotions');
        }

        // If this collection is explicitly set to "Manual" sort in the dashboard, reorder
        // results to match Shopify's drag-drop order and skip the boost-rules sort below.
        // Apply when currentSort is 'manual' (the rule's default) OR 'relevance' (fallback) —
        // only skip when the customer explicitly picked a different sort like price-asc.
        if (isManualSortCollection() && (currentSort === 'manual' || currentSort === 'relevance')) {
          console.log('📋 Manual sort enabled for this collection — using Shopify order');
          products = reorderByManual(products);
        }
  
        // Boost rules pin specific products to the top — skip them when this collection is
        // set to Manual sort and the customer hasn't picked a different sort, otherwise
        // pin-to-top would fight the boss's drag-drop order.
        if (boostRules.length > 0 && !(isManualSortCollection() && (currentSort === 'manual' || currentSort === 'relevance'))) {
          DEBUG && console.log('🚀 Applying boost rules to results (pinning to top)');
  
          // Debug: Find ALL products with the target tag BEFORE scoring
          const tagRule = boostRules.find(r => r.boostType === 'tag');
          if (tagRule) {
            const productsWithTag = products.filter(p => p.tags && p.tags.includes(tagRule.boostValue));
            DEBUG && console.log(`🔍 Searching all ${products.length} products for tag "${tagRule.boostValue}"...`);
            DEBUG && console.log(`✨ Found ${productsWithTag.length} products with tag:`, productsWithTag.map(p => p.full_title));
          }
  
          // Debug: Check if the specific product "N200-0019" exists in results
          const targetProduct = products.find(p =>
            (p.sku && p.sku.includes('N200-0019')) ||
            (p.full_title && p.full_title.includes('N200-0019')) ||
            (p.title && p.title.includes('N200-0019'))
          );
          if (targetProduct) {
            DEBUG && console.log('🎯 Found target product N200-0019:', {
              title: targetProduct.full_title || targetProduct.title,
              sku: targetProduct.sku,
              tags: targetProduct.tags,
              price: targetProduct.price,
              id: targetProduct.id
            });
          } else {
            DEBUG && console.log('❌ Product N200-0019 NOT found in the ' + products.length + ' results returned by Meilisearch');
          }
  
          // Calculate boost scores for all products
          products = products.map((p, index) => {
            const isTarget = p.sku && p.sku.includes('N200-0019');
            const score = calculateBoostScore(p, index < 3 || isTarget);
            const baseScore = p.ranking_score || 100;
            const hasExplicitBoost = score > baseScore;
  
            if (isTarget) {
              DEBUG && console.log('💯 Target product boost calculation:', {
                title: p.full_title || p.title,
                baseScore: baseScore,
                calculatedScore: score,
                willBeBoosted: hasExplicitBoost,
                tags: p.tags,
                boostRulesCount: boostRules.length
              });
            }
  
            return { ...p, boostedScore: score, hasExplicitBoost };
          });
  
          // Separate into explicitly-boosted (from rules) vs everything else
          const boostedProducts = products.filter(p => p.hasExplicitBoost);
          const nonBoostedProducts = products.filter(p => !p.hasExplicitBoost);
  
          // Debug: Check if target is in boosted array
          const targetInBoosted = boostedProducts.find(p => p.sku && p.sku.includes('N200-0019'));
          if (targetInBoosted) {
            DEBUG && console.log('✅ Target product IS in boosted array with score:', targetInBoosted.boostedScore);
          } else {
            const targetInNonBoosted = nonBoostedProducts.find(p => p.sku && p.sku.includes('N200-0019'));
            if (targetInNonBoosted) {
              DEBUG && console.log('❌ Target product is in NON-BOOSTED array! Score:', targetInNonBoosted.boostedScore);
            }
          }
  
          // Sort boosted products by boost score (highest first)
          boostedProducts.sort((a, b) => b.boostedScore - a.boostedScore);
  
          // Sort non-boosted products by the current sort option
          // (they're already sorted by Meilisearch, so we keep that order)
  
          // Combine: boosted first, then non-boosted
          // Apply category priority bucketing to non-boosted products (if rule set)
          let nonBoostedOrdered = nonBoostedProducts;
          if (collectionRule && Array.isArray(collectionRule.categoryPriority) && collectionRule.categoryPriority.length > 0) {
            const buckets = {};
            const order = collectionRule.categoryPriority.slice();
            order.forEach(c => buckets[c] = []);
            const other = [];
            nonBoostedProducts.forEach(p => {
              const cat = p['custom.product_category'] || p['custom.product_type'] || '';
              if (buckets[cat]) buckets[cat].push(p);
              else other.push(p);
            });
            nonBoostedOrdered = [];
            order.forEach(c => { nonBoostedOrdered = nonBoostedOrdered.concat(buckets[c]); });
            nonBoostedOrdered = nonBoostedOrdered.concat(other);
          }
  
          products = [...boostedProducts, ...nonBoostedOrdered];
  
          DEBUG && console.log(`📌 Pinned ${boostedProducts.length} boosted products to top`);
          if (boostedProducts.length > 0) {
            DEBUG && console.log('🥇 POSITION #1 PRODUCT:', {
              title: products[0].full_title || products[0].title,
              sku: products[0].sku,
              boostedScore: products[0].boostedScore,
              price: products[0].price,
              isTargetProduct: products[0].sku && products[0].sku.includes('N200-0019')
            });
            DEBUG && console.log('🥈 First 3 products after pinning:', products.slice(0, 3).map(p => ({
              title: p.full_title || p.title,
              sku: p.sku,
              boostedScore: p.boostedScore,
              price: p.price
            })));
          }
        }
  
        // Apply category priority bucketing when there are no boost rules (otherwise done above)
        if (boostRules.length === 0 && collectionRule && Array.isArray(collectionRule.categoryPriority) && collectionRule.categoryPriority.length > 0) {
          const buckets = {};
          const order = collectionRule.categoryPriority.slice();
          order.forEach(c => buckets[c] = []);
          const other = [];
          products.forEach(p => {
            const cat = p['custom.product_category'] || p['custom.product_type'] || '';
            if (buckets[cat]) buckets[cat].push(p);
            else other.push(p);
          });
          let reordered = [];
          order.forEach(c => { reordered = reordered.concat(buckets[c]); });
          products = reordered.concat(other);
        }

        // Demote unavailable products to the bottom of the result list.
        // Preserves the relative order within each group (boosted/categorized order stays intact).
        // p.available is set by Shopify (true when at least one variant can be added to cart).
        // Treat undefined as available to avoid penalizing legacy docs.
        {
          const availableProducts = products.filter(p => p.available !== false);
          const unavailableProducts = products.filter(p => p.available === false);
          if (unavailableProducts.length > 0) {
            products = [...availableProducts, ...unavailableProducts];
            DEBUG && console.log(`📉 Demoted ${unavailableProducts.length} unavailable products to bottom`);
          }
        }

        // Store all products (after boost sorting / post-filtering) when we did a full fetch
        // This ensures accurate pagination and counts for boost rules and promotion/clearance
        if (!loadMore) {
          if (needsFullFetch) {
            allProductsBeforePagination = products; // Store ALL filtered products for pagination
            totalEstimatedHits = products.length; // Use post-filtered count
          } else {
            allProductsBeforePagination = []; // Clear when not using full fetch
          }
          currentPage = 1;
        }
  
        // Slice products for current page display
        const displayCount = loadMore ? (currentPage + 1) * productsPerPage : productsPerPage;
        const productsToDisplay = allProductsBeforePagination.length > 0
          ? allProductsBeforePagination.slice(0, displayCount)
          : products.slice(0, displayCount);
  
        allProducts = productsToDisplay;
  
        if (loadMore) {
          currentPage++;
        }
  
        if (allProducts.length === 0) {
          showNoResults();
          buildFacets([]);
          syncToURL();
          return;
        }
  
        // Build facets from ALL products (not just displayed ones)
        const facetSource = allProductsBeforePagination.length > 0
          ? allProductsBeforePagination
          : allProducts;
        buildFacets(facetSource);
  
        // Hide quick filters that have no matching products in this collection
        updateQuickFilterVisibility(facetDistribution, facetSource);
  
        // Debug: Log what's being passed to displayResults
        if (allProducts.length > 0) {
          DEBUG && console.log('📺 About to display results. First product is:', {
            title: allProducts[0].full_title || allProducts[0].title,
            sku: allProducts[0].sku,
            price: allProducts[0].price,
            isTargetProduct: allProducts[0].sku && allProducts[0].sku.includes('N200-0019')
          });
          DEBUG && console.log(`📊 Displaying ${allProducts.length} of ${allProductsBeforePagination.length || totalEstimatedHits || allProducts.length} total products`);
        }

        // Preserve scroll position AND avoid visual glitch across Load More.
        // displayResults rewrites resultsGrid.innerHTML — this both collapses the page (loses
        // scroll position) and recreates every existing card (re-triggers their CSS transitions
        // and image decoding, which the user perceives as a glitch). Workaround:
        //   1. Cache the live DOM nodes of cards currently on screen
        //   2. Anchor scroll on the topmost visible card
        //   3. Let displayResults wipe + repopulate (synchronously — no paint occurs mid-way)
        //   4. Walk the new grid; for cards whose id matches a cached node, swap the fresh
        //      node back out for the cached one. Same data, untouched DOM, no flicker.
        let anchor = null;
        let cardCache = null;
        if (loadMore && els.resultsGrid) {
          cardCache = new Map();
          for (const card of els.resultsGrid.querySelectorAll('.product-card[data-product-id]')) {
            cardCache.set(card.getAttribute('data-product-id'), card);
          }
          for (const card of cardCache.values()) {
            const r = card.getBoundingClientRect();
            if (r.bottom > 0) { anchor = { id: card.getAttribute('data-product-id'), top: r.top }; break; }
          }
        }
        displayResults(allProducts);
        if (cardCache && cardCache.size) {
          for (const newCard of els.resultsGrid.querySelectorAll('.product-card[data-product-id]')) {
            const cached = cardCache.get(newCard.getAttribute('data-product-id'));
            if (cached) newCard.replaceWith(cached);
          }
          console.log('🔒 [loadMore] reused', cardCache.size, 'existing card DOM nodes');
        }
        if (anchor) {
          const restore = () => {
            const el = document.querySelector(`.product-card[data-product-id="${anchor.id}"]`);
            if (el) window.scrollBy(0, el.getBoundingClientRect().top - anchor.top);
          };
          restore();
          requestAnimationFrame(restore);
          setTimeout(restore, 300);
        }
        updateCompareBar();
        syncToURL();
  
        // Show load more button if there are more results to fetch
        const loadMoreContainer = document.getElementById('load-more-container');
        const loadMoreBtn = document.getElementById('load-more-btn');
        const totalProducts = allProductsBeforePagination.length > 0
          ? allProductsBeforePagination.length
          : totalEstimatedHits;
        const remaining = totalProducts - allProducts.length;
  
        if (remaining > 0) {
          loadMoreContainer.style.display = 'block';
          if (loadMoreBtn) {
            loadMoreBtn.textContent = `Load More Products (${remaining} remaining)`;
          }
        } else {
          loadMoreContainer.style.display = 'none';
        }
  
      } catch (error) {
        DEBUG && console.error('❌ Collection search error:', error);
        showError(error);
      }
    }
  
    function updateQuickFilterVisibility(facets, products) {
      // New Arrivals: check if any products have season_code "2026"
      const newArrivalEl = document.getElementById('filter-new-arrival');
      if (newArrivalEl) {
        const hasNewArrivals = facets?.season_code?.['2026'] > 0;
        newArrivalEl.closest('label').style.display = hasNewArrivals ? 'flex' : 'none';
      }
  
      // Canadian Brands: check if any products have "Canadian Brand" tag
      const canadianEl = document.getElementById('filter-canadian-brands');
      if (canadianEl) {
        const hasCanadian = facets?.tags?.['Canadian Brand'] > 0;
        canadianEl.closest('label').style.display = hasCanadian ? 'flex' : 'none';
      }
  
      // Promotion & Clearance: both require on_sale products, then check price endings
      const promoEl = document.getElementById('filter-promotion');
      const clearanceEl = document.getElementById('filter-clearance');
      const hasOnSale = facets?.on_sale?.['true'] > 0;
  
      // Check for GWP promo products and offer_type Promotions
      const hasGwpProducts = products.some(p => hasGwpPromo(p.tags));
      const hasOfferPromo = products.some(p => p['custom.offer_type'] === 'Promotions');
  
      if ((hasOnSale && products.length > 0) || hasGwpProducts || hasOfferPromo) {
        // Check actual products for .97 (clearance) vs non-.97 (promotion) pricing
        // Only count products that Meilisearch marks as on_sale (not just compare_at > 0)
        const saleProducts = products.filter(p => p.on_sale === true || p.on_sale === 'true');
        const hasClearance = saleProducts.some(p => Math.round(p.price * 100) % 100 === 97);
        const hasPromotion = saleProducts.some(p => Math.round(p.price * 100) % 100 !== 97) || hasGwpProducts || hasOfferPromo;
  
        if (clearanceEl) clearanceEl.closest('label').style.display = hasClearance ? 'flex' : 'none';
        if (promoEl) promoEl.closest('label').style.display = hasPromotion ? 'flex' : 'none';
      } else {
        if (clearanceEl) clearanceEl.closest('label').style.display = 'none';
        if (promoEl) promoEl.closest('label').style.display = 'none';
      }
  
      // Hide the entire quick-filters section if all filters are hidden
      const section = document.getElementById('quick-filters-section');
      if (section) {
        const visibleLabels = section.querySelectorAll('label');
        const anyVisible = Array.from(visibleLabels).some(l => l.style.display !== 'none');
        section.style.display = anyVisible ? 'flex' : 'none';
      }
  
      DEBUG && console.log('🔘 Quick filter visibility updated', {
        newArrivals: facets?.season_code?.['2026'] || 0,
        onSale: facets?.on_sale?.['true'] || 0,
        canadianBrand: facets?.tags?.['Canadian Brand'] || 0
      });
    }
  
    function buildFacets(products) {
      function getHexColor(colorName) {
        if (filterConfig?.colorHexCodes) {
          if (filterConfig.colorHexCodes[colorName]) return filterConfig.colorHexCodes[colorName];
          const configKey = Object.keys(filterConfig.colorHexCodes).find(key => key.toLowerCase() === colorName.toLowerCase());
          if (configKey) return filterConfig.colorHexCodes[configKey];
        }
        const colorMap = { 'black': '#000000', 'white': '#FFFFFF', 'red': '#DC2626', 'blue': '#2563EB', 'green': '#059669', 'yellow': '#EAB308', 'orange': '#EA580C', 'purple': '#9333EA', 'pink': '#EC4899', 'gray': '#6B7280', 'grey': '#6B7280', 'brown': '#92400E', 'navy': '#1E3A8A', 'silver': '#C0C0C0', 'gold': '#FFD700', 'beige': '#F5F5DC', 'stainless': '#C0C0C0', 'charcoal': '#36454F' };
        const lower = colorName.toLowerCase();
        if (colorMap[lower]) return colorMap[lower];
        for (const [key, value] of Object.entries(colorMap)) { if (lower.startsWith(key)) return value; }
        if (lower.includes('stainless')) return '#C0C0C0';
        return '#E5E7EB';
      }
  
      // Helper: render a standard checkbox list filter
      function renderCheckboxFilter(containerId, facetData, stateSet, filterType, sortFn, options) {
        const container = document.getElementById(containerId);
        const section = container?.closest('div[style*="margin-bottom"]') || container?.parentElement;
        if (!container) return;
        // Merge in every value we've SEEN in this facet so far (so multi-select stays possible
        // — Meilisearch drops unselected values from the distribution when a filter is active),
        // plus any active selections that might not be in either set. Counts default to 0 for
        // values not present in the current filtered distribution.
        const mergedData = { ...facetData };
        const seenKey = options?.seenKey;
        if (seenKey && seenFacetValues[seenKey]) {
          seenFacetValues[seenKey].forEach(v => { if (!(v in mergedData)) mergedData[v] = 0; });
        }
        stateSet.forEach(v => { if (!(v in mergedData)) mergedData[v] = 0; });
        const entries = Object.entries(mergedData);
        if (entries.length === 0 || (options?.hideIfSingle && entries.length <= 1 && stateSet.size === 0)) { if (section) section.style.display = 'none'; return; }
        if (section) section.style.display = 'block';
        // Sort: active (checked) items first when counts are 0, then by count desc
        const sorted = sortFn ? entries.sort(sortFn) : entries.sort((a, b) => {
          const aChecked = stateSet.has(a[0]) ? 1 : 0;
          const bChecked = stateSet.has(b[0]) ? 1 : 0;
          if (aChecked !== bChecked) return bChecked - aChecked;
          return b[1] - a[1];
        });
        const showSearch = entries.length > 8;
        const searchHtml = showSearch ? `
          <div style="position: sticky; top: 0; background: #fff; padding: 0 0 8px 0; z-index: 1;">
            <input type="text" placeholder="Search..." class="filter-search-input" style="width: 100%; padding: 7px 10px; border: 1px solid #e0e0e0; border-radius: 6px; font-size: 13px; outline: none; box-sizing: border-box; color: #1a1a1a; transition: border-color 0.15s;" onfocus="this.style.borderColor='#999'" onblur="this.style.borderColor='#e0e0e0'">
          </div>
        ` : '';
        const displayLabel = (v) => v === 'true' ? 'Yes' : v === 'false' ? 'No' : v;
        const labelsHtml = sorted.map(([value, count]) => `
          <label style="display: flex; align-items: center; padding: 8px 6px; cursor: pointer; font-size: 14px; border-radius: 4px; margin: 0 -6px; transition: background 0.15s;" onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='transparent'" data-filter-value="${escapeHtml(value.toLowerCase())}">
            <input type="checkbox" value="${escapeHtml(value)}" ${stateSet.has(value) ? 'checked' : ''} data-filter-type="${filterType}" class="filter-checkbox" style="margin-right: 10px; cursor: pointer; width: 17px; height: 17px; accent-color: #1a1a1a;">
            <span style="flex: 1; color: #1a1a1a; font-weight: 400;">${escapeHtml(displayLabel(value))}</span>
            <span style="color: #9ca3af; font-size: 12px; font-weight: 400;">${count}</span>
          </label>
        `).join('');
        if (showSearch) {
          container.style.maxHeight = '320px';
          container.style.overflowY = 'auto';
          container.style.overflowX = 'hidden';
          container.style.paddingRight = '15px';
        } else {
          container.style.maxHeight = '';
          container.style.overflowY = '';
          container.style.overflowX = '';
          container.style.paddingRight = '';
        }
        container.innerHTML = searchHtml + labelsHtml;
        if (showSearch) {
          const searchInput = container.querySelector('.filter-search-input');
          searchInput.addEventListener('input', function() {
            const query = this.value.toLowerCase().trim();
            container.querySelectorAll('label[data-filter-value]').forEach(label => {
              label.style.display = !query || label.dataset.filterValue.includes(query) ? 'flex' : 'none';
            });
          });
        }
        container.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.addEventListener('change', handleFilterChange));
      }

      // Current Offers — uses metafield filter pipeline (custom.sale_offer_name)
      function renderOffersFilter(facetData) {
        const block = document.getElementById('current-offers-block');
        const container = document.getElementById('current-offers-filter-options');
        if (!block || !container) return;

        const activeOffers = currentFilters.metafields['custom.sale_offer_name'] || new Set();
        const merged = { ...facetData };
        // Preserve every offer we've seen so far so multi-select stays available
        // (Meilisearch drops unselected offers from the distribution once one is active).
        if (seenFacetValues['custom.sale_offer_name']) {
          seenFacetValues['custom.sale_offer_name'].forEach(v => { if (!(v in merged)) merged[v] = 0; });
        }
        activeOffers.forEach(v => { if (!(v in merged)) merged[v] = 0; });
        const entries = Object.entries(merged);

        if (entries.length === 0) { block.style.display = 'none'; return; }
        block.style.display = 'block';

        // Sort: active checked first, then A-Z by offer name (locale-aware, case-insensitive).
        entries.sort((a, b) => {
          const aChecked = activeOffers.has(a[0]) ? 1 : 0;
          const bChecked = activeOffers.has(b[0]) ? 1 : 0;
          if (aChecked !== bChecked) return bChecked - aChecked;
          return a[0].localeCompare(b[0], undefined, { sensitivity: 'base' });
        });

        const INITIAL_LIMIT = 5;
        // Keep the toggle persistent across re-renders (e.g. when other filters apply)
        const expanded = container.dataset.offersExpanded === 'true';
        const hasMore = entries.length > INITIAL_LIMIT;

        const labelHtml = ([value, count]) => `
          <label style="display: flex; align-items: center; padding: 8px 6px; cursor: pointer; font-size: 14px; border-radius: 4px; margin: 0 -6px; transition: background 0.15s;" onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='transparent'">
            <input type="checkbox" value="${escapeHtml(value)}" ${activeOffers.has(value) ? 'checked' : ''} data-filter-type="metafield" data-metafield-key="custom.sale_offer_name" class="filter-checkbox" style="margin-right: 10px; cursor: pointer; width: 17px; height: 17px; accent-color: #1a1a1a;">
            <span style="flex: 1; color: #1a1a1a; font-weight: 400;">${escapeHtml(value)}</span>
            <span style="color: #9ca3af; font-size: 12px; font-weight: 400;">${count}</span>
          </label>
        `;

        const visible = (hasMore && !expanded) ? entries.slice(0, INITIAL_LIMIT) : entries;
        const toggleBtn = hasMore
          ? `<button type="button" data-offers-toggle style="background: none; border: none; padding: 8px 6px; margin: 4px -6px 0; cursor: pointer; font-size: 13px; color: #1a1a1a; font-weight: 600; text-decoration: underline; display: block;">${expanded ? 'Show less' : `Show ${entries.length - INITIAL_LIMIT} more`}</button>`
          : '';

        container.innerHTML = visible.map(labelHtml).join('') + toggleBtn;

        container.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.addEventListener('change', handleFilterChange));

        const btn = container.querySelector('[data-offers-toggle]');
        if (btn) {
          btn.addEventListener('click', () => {
            container.dataset.offersExpanded = expanded ? 'false' : 'true';
            renderOffersFilter(facetData);
          });
        }
      }

      // Numeric sort helper
      const numericSort = (a, b) => { const an = parseFloat(a[0]), bn = parseFloat(b[0]); return (!isNaN(an) && !isNaN(bn)) ? an - bn : a[0].localeCompare(b[0]); };
  
      // Build color families (a single color can match multiple families)
      let colorFamilies = {};
      const rawColors = facetDistribution?.color || {};
      Object.entries(rawColors).forEach(([color, count]) => {
        const families = getColorFamilies(color);
        families.forEach(family => { colorFamilies[family] = (colorFamilies[family] || 0) + count; });
      });
      // Keep every family we've EVER seen so multi-select survives filter state changes
      if (!seenFacetValues.__color_families) seenFacetValues.__color_families = new Set();
      Object.keys(colorFamilies).forEach(f => seenFacetValues.__color_families.add(f));
      seenFacetValues.__color_families.forEach(f => { if (!(f in colorFamilies)) colorFamilies[f] = 0; });
  
      // 0. Current Offers (custom.sale_offer_name) — rendered above all filters
      renderOffersFilter(facetDistribution?.['custom.sale_offer_name'] || {});

      // 1. Product Category (custom.product_category metafield, fallback to legacy custom.product_type)
      renderCheckboxFilter('product-category-filter-options', facetDistribution?.['custom.product_category'] || facetDistribution?.['custom.product_type'] || {}, currentFilters.productCategory, 'product-category', null, { hideIfSingle: true, seenKey: 'custom.product_category' });

      // 2. Product Type (custom.product_type_v2 metafield, fallback to legacy custom.filter_by_style)
      renderCheckboxFilter('product-type-filter-options', facetDistribution?.['custom.product_type_v2'] || facetDistribution?.['custom.filter_by_style'] || {}, currentFilters.productType, 'product-type', null, { hideIfSingle: true, seenKey: 'custom.product_type_v2' });

      // 3. Configuration (custom.grill_configuration metafield)
      renderCheckboxFilter('configuration-filter-options', facetDistribution?.['custom.grill_configuration'] || {}, currentFilters.configuration, 'configuration', null, { hideIfSingle: true, seenKey: 'custom.grill_configuration' });

      // 4. Brand
      renderCheckboxFilter('brand-filter-options', facetDistribution?.vendor || {}, currentFilters.brands, 'brand', null, { hideIfSingle: true, seenKey: 'vendor' });

      // 5. Fuel Type
      renderCheckboxFilter('fuel-type-filter-options', facetDistribution?.fuel_type || {}, currentFilters.fuelTypes, 'fuel_type', null, { hideIfSingle: true, seenKey: 'fuel_type' });

      // Legacy filters (kept for backwards compat with old URL params)
      renderCheckboxFilter('taxonomy-configuration-filter-options', facetDistribution?.taxonomy_configuration || {}, currentFilters.taxonomy.configuration, 'taxonomy-configuration', null, { hideIfSingle: true, seenKey: 'taxonomy_configuration' });
      renderCheckboxFilter('type-filter-options', facetDistribution?.taxonomy_category || {}, currentFilters.types, 'type', null, { hideIfSingle: true, seenKey: 'taxonomy_category' });

      // 5. Price - handled by price slider (no checkbox list)

      // 6. Series
      renderCheckboxFilter('series-filter-options', facetDistribution?.['general_specs.series'] || {}, currentFilters.series, 'series', null, { hideIfSingle: true, seenKey: 'general_specs.series' });

      // 7. Main Burners
      renderCheckboxFilter('main-burners-filter-options', facetDistribution?.['bbq_specs.main_burner_count'] || {}, currentFilters.mainBurners, 'main-burners', numericSort, { hideIfSingle: true, seenKey: 'bbq_specs.main_burner_count' });

      // 8. Side Burners
      renderCheckboxFilter('side-burners-filter-options', facetDistribution?.['bbq_specs.side_burner_included'] || {}, currentFilters.sideBurners, 'side-burners', null, { hideIfSingle: true, seenKey: 'bbq_specs.side_burner_included' });
  
      // 9. Rear/Rotisserie Burner - combine two fields into one facet display
      const rrData = {};
      const rotisserie = facetDistribution?.['bbq_specs.rotisserie_included'] || {};
      const rearBurner = facetDistribution?.['bbq_specs.rear_burner_included'] || {};
      Object.entries(rotisserie).forEach(([v, c]) => { rrData[v] = (rrData[v] || 0) + c; });
      Object.entries(rearBurner).forEach(([v, c]) => { rrData[v] = (rrData[v] || 0) + c; });
      // Persist union across both underlying keys so multi-select works here too
      if (!seenFacetValues.__rear_rotisserie) seenFacetValues.__rear_rotisserie = new Set();
      Object.keys(rrData).forEach(v => seenFacetValues.__rear_rotisserie.add(v));
      renderCheckboxFilter('rear-rotisserie-filter-options', rrData, currentFilters.rearRotisserie, 'rear-rotisserie', null, { hideIfSingle: true, seenKey: '__rear_rotisserie' });
  
      // 10. Color (swatches)
      const colorContainer = document.getElementById('color-filter-options');
      const colorSection = colorContainer?.parentElement;
      if (colorContainer) {
        // Merge in active color selections for 0-result scenario
        currentFilters.colors.forEach(c => { if (!(c in colorFamilies)) colorFamilies[c] = 0; });
        if (Object.keys(colorFamilies).length === 0) {
          if (colorSection) colorSection.style.display = 'none';
        } else {
          if (colorSection) colorSection.style.display = 'block';
          colorContainer.innerHTML = `<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
            ${Object.entries(colorFamilies).sort((a, b) => b[1] - a[1]).map(([family, count]) => {
              const hexColor = getHexColor(family);
              const borderColor = family.toLowerCase().includes('white') ? '#d1d5db' : hexColor;
              const safeFamily = escapeHtml(family);
              return `<label style="display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 13px;" onmouseover="this.style.opacity='0.7'" onmouseout="this.style.opacity='1'">
                <input type="checkbox" value="${safeFamily}" ${currentFilters.colors.has(family) ? 'checked' : ''} data-filter-type="color" class="filter-checkbox" aria-label="Filter by color: ${safeFamily}" style="display: none;">
                <div style="width: 20px; height: 20px; border-radius: 50%; background: ${hexColor}; border: 2px solid ${borderColor}; flex-shrink: 0; box-shadow: 0 0 0 1px rgba(0,0,0,0.1);"></div>
                <span style="color: #1a1a1a; font-weight: 400; flex: 1;">${safeFamily}</span>
                <span style="color: #9ca3af; font-size: 12px; font-weight: 400;">${count}</span>
              </label>`;
            }).join('')}
          </div>`;
          colorContainer.querySelectorAll('input').forEach(cb => cb.addEventListener('change', handleFilterChange));
        }
      }
  
      // 11. Availability
      renderCheckboxFilter('availability-filter-options', facetDistribution?.['custom.availability_faceted_navigation'] || {}, currentFilters.availability, 'availability', null, { hideIfSingle: true, seenKey: 'custom.availability_faceted_navigation' });
  
      // Remove border from last visible filter
      const filterContainer = document.getElementById('dynamic-filters-container');
      if (filterContainer) {
        const allFilters = filterContainer.querySelectorAll(':scope > div');
        allFilters.forEach(f => f.classList.remove('last-visible-filter'));
        const visible = Array.from(allFilters).filter(f => f.style.display !== 'none');
        if (visible.length > 0) {
          visible[visible.length - 1].classList.add('last-visible-filter');
        }
      }
    }
  
    // Group variants by handle + fuel type (separate card per fuel type)
    function groupProductsByHandle(products) {
      const grouped = {};
  
      for (const product of products) {
        const urlMatch = product.url?.match(/\/products\/([^?#\/]+)/);
        const handle = urlMatch ? urlMatch[1] : product.id;
  
        // Determine this variant's color value
        let variantColor = null;
        const hasAnyOption = product.option1_name || product.option2_name || product.option3_name;
        if (hasAnyOption) {
          for (let i = 1; i <= 3; i++) {
            const optName = product[`option${i}_name`];
            const optVal = product[`option${i}_value`];
            if (!optName || !optVal) continue;
            if (optName === 'Title' && optVal === 'Default Title') continue;
            const key = optName.toLowerCase();
            if (key === 'color' || key === 'colour') {
              variantColor = optVal;
              break;
            }
          }
        } else if (product.color) {
          variantColor = product.color;
        }
  
        // Group by handle + color so each color gets its own card
        const groupKey = variantColor ? `${handle}::${variantColor}` : handle;
  
        const thirtyDaysAgo = Date.now() - (30 * 24 * 60 * 60 * 1000);
        const isNew = product.published_at && product.published_at >= thirtyDaysAgo;
        const isCanadian = product.tags && product.tags.includes('Canadian Brand');
        const isGwp = hasGwpPromo(product.tags);
  
        if (!grouped[groupKey]) {
          grouped[groupKey] = {
            main: product,
            variants: [product],
            colorName: variantColor,
            lowestPrice: product.price,
            lowestPriceCompareAt: product.compare_at_price || 0,
            hasOnSale: product.compare_at_price > product.price && product.price > 0,
            isNewArrival: isNew,
            isCanadian: isCanadian,
            hasGwpPromo: isGwp,
            /* PROMO only when THIS variant is actually discounted — offer_type is product-level
               so without this check, non-sale color variants inherit the PROMO badge from a
               single on-sale sibling. */
            hasPromo: product['custom.offer_type'] === 'Promotions' && product.compare_at_price > product.price && product.price > 0
          };
        } else {
          grouped[groupKey].variants.push(product);
          if (product.price < grouped[groupKey].lowestPrice) {
            grouped[groupKey].lowestPrice = product.price;
            grouped[groupKey].lowestPriceCompareAt = product.compare_at_price || 0;
          }
          if (product.compare_at_price > product.price && product.price > 0) {
            grouped[groupKey].hasOnSale = true;
          }
          if (isNew) {
            grouped[groupKey].isNewArrival = true;
          }
          if (isCanadian) {
            grouped[groupKey].isCanadian = true;
          }
          if (isGwp) {
            grouped[groupKey].hasGwpPromo = true;
          }
          if (product['custom.offer_type'] === 'Promotions' && product.compare_at_price > product.price && product.price > 0) {
            grouped[groupKey].hasPromo = true;
          }
        }
      }
  
      return Object.values(grouped);
    }
  
    function displayResults(products) {
      DEBUG && console.log('📦 Displaying products:', products.length);
      if (products.length > 0) {
        DEBUG && console.log('🔍 Sample product fields:', Object.keys(products[0]));
      }
      hideLoading();
      els.resultsHeader.style.display = 'block';

      // Group products by handle (one card per unique product)
      const groupedProducts = groupProductsByHandle(products);
  
      // Re-sort grouped products to maintain sort order after grouping
      if (currentSort === 'price-asc') {
        groupedProducts.sort((a, b) => a.lowestPrice - b.lowestPrice);
      } else if (currentSort === 'price-desc') {
        groupedProducts.sort((a, b) => b.lowestPrice - a.lowestPrice);
      } else if (currentSort === 'newest') {
        groupedProducts.sort((a, b) => (b.main.created_at || 0) - (a.main.created_at || 0));
      } else if (currentSort === 'oldest') {
        groupedProducts.sort((a, b) => (a.main.created_at || 0) - (b.main.created_at || 0));
      }
  
      // Count how many color groups each base handle has
      const handleColorCount = {};
      for (const group of groupedProducts) {
        const h = group.main.url?.match(/\/products\/([^?#\/]+)/)?.[1] || group.main.id;
        handleColorCount[h] = (handleColorCount[h] || 0) + 1;
      }
      // Tag each group so we know whether to show color in title
      for (const group of groupedProducts) {
        const h = group.main.url?.match(/\/products\/([^?#\/]+)/)?.[1] || group.main.id;
        group.showColorInTitle = handleColorCount[h] > 1;
      }
  
      DEBUG && console.log('📦 Grouped into', groupedProducts.length, 'unique products');
  
      // Show total product count — use Meilisearch totalEstimatedHits for accurate count
      // instead of groupedProducts.length which is capped by the per-page limit
      const displayTotal = totalEstimatedHits || groupedProducts.length;
      els.resultsCount.innerHTML = `<span style="font-weight: 600;">${collectionTitle}</span> <span style="color: #666; font-weight: 400;">${displayTotal} products</span>`;
  
      // Update mobile product count
      const mobileCount = document.getElementById('mobile-product-count');
      if (mobileCount) {
        mobileCount.textContent = `${displayTotal} Products`;
      }
  
      // Update mobile view products button
      const viewProductsBtn = document.getElementById('view-products-btn');
      if (viewProductsBtn) {
        viewProductsBtn.textContent = `VIEW ${displayTotal} PRODUCTS`;
      }
  
      // Helper function to get hex color
      function getProductHexColor(colorName) {
        if (!colorName) return '#E5E7EB';
        if (filterConfig?.colorHexCodes) {
          if (filterConfig.colorHexCodes[colorName]) {
            return filterConfig.colorHexCodes[colorName];
          }
          const configKey = Object.keys(filterConfig.colorHexCodes).find(
            key => key.toLowerCase() === colorName.toLowerCase()
          );
          if (configKey) {
            return filterConfig.colorHexCodes[configKey];
          }
        }
        const colorMap = {
          'black': '#000000', 'white': '#FFFFFF', 'red': '#DC2626', 'blue': '#2563EB',
          'green': '#059669', 'yellow': '#EAB308', 'orange': '#EA580C', 'purple': '#9333EA',
          'pink': '#EC4899', 'gray': '#6B7280', 'grey': '#6B7280', 'brown': '#92400E',
          'navy': '#1E3A8A', 'silver': '#C0C0C0', 'gold': '#FFD700', 'beige': '#F5F5DC',
          'stainless': '#C0C0C0', 'charcoal': '#36454F'
        };
        const lower = colorName.toLowerCase();
        if (colorMap[lower]) return colorMap[lower];
        for (const [key, value] of Object.entries(colorMap)) {
          if (lower.includes(key)) return value;
        }
        return '#E5E7EB';
      }
  
      els.resultsGrid.innerHTML = groupedProducts.map((group, index) => {
        const product = group.main;
        const imageUrl = product.image_url || '';
        const vendor = escapeHtml(product.vendor || '');
        const safeTitle = escapeHtml(product.title || '');
        const safeSku = escapeHtml(product.sku || product.variant_sku || '');
  
        // LCP optimization: First 4 images get high priority
        const isAboveFold = index < 4;
        const imgPriority = isAboveFold ? 'fetchpriority="high" loading="eager"' : 'loading="lazy" decoding="async"';
  
        // Price display — "Starting from" using lowest price in the group
        const lowestPrice = group.lowestPrice;
        const hasMultipleVariants = group.variants.length > 1;
  
        let priceHTML = '';
        if (lowestPrice > 0) {
          if (hasMultipleVariants && group.hasOnSale && group.lowestPriceCompareAt > lowestPrice) {
            // Multiple variants with sale — show "Starting from" with strikethrough
            priceHTML = `<span style="font-size: 12px; font-weight: 400; color: #666;">Starting from</span> <span class="current-price" style="font-size: 18px; font-weight: 700; color: #dc2626;">$${formatPrice(lowestPrice)}</span>
              <span class="compare-price" style="font-size: 14px; color: #9ca3af; text-decoration: line-through; margin-left: 4px;">$${formatPrice(group.lowestPriceCompareAt)}</span>`;
          } else if (hasMultipleVariants) {
            priceHTML = `<span style="font-size: 12px; font-weight: 400; color: #666;">Starting from</span> <span class="current-price" style="font-size: 18px; font-weight: 700; color: #1a1a1a;">$${formatPrice(lowestPrice)}</span>`;
          } else if (product.compare_at_price && product.compare_at_price > product.price && product.price > 0) {
            priceHTML = `
              <span class="current-price" style="font-size: 18px; font-weight: 700; color: #dc2626;">$${formatPrice(product.price)}</span>
              <span class="compare-price" style="font-size: 14px; color: #9ca3af; text-decoration: line-through; margin-left: 4px;">$${formatPrice(product.compare_at_price)}</span>
            `;
          } else {
            priceHTML = `<span class="current-price" style="font-size: 18px; font-weight: 700; color: #1a1a1a;">$${formatPrice(product.price)}</span>`;
          }
        }
  
        // Affirm "as low as" line (only for products $100+)
        const affirmPrice = hasMultipleVariants ? lowestPrice : product.price;
        const affirmCents = Math.round(affirmPrice * 100);
        const affirmHTML = affirmPrice >= 100 ? `
          <div style="margin-top: 6px;">
            <p class="affirm-as-low-as" data-page-type="product" data-amount="${affirmCents}" style="margin: 0; font-size: 12px; color: #666;">As low as...</p>
          </div>
        ` : '';
  
        const isInCompare = compareProducts.has(product.id);
        const productHandle = product.url?.match(/\/products\/([^?#\/]+)/)?.[1] || product.id;
  
        // Color suffix for title (e.g. " - Black") — only when multiple colors exist
        let colorSuffix = '';
        if (group.colorName && group.showColorInTitle) {
          colorSuffix = ` - ${group.colorName}`;
        }
  
        // SKU line
        const skuHTML = safeSku ? `<div style="font-size: 12px; color: #9ca3af; margin-top: 8px;">SKU: ${safeSku}</div>` : '';
  
        // Product URL without variant query params
        const productUrl = product.url ? escapeHtml(product.url.split('?')[0]) : '#';
  
        return `
          <div class="product-card${isInCompare ? ' product-card--comparing' : ''}" data-handle="${productHandle}" data-product-id="${product.id}" style="position: relative; background: white; border: 1px solid ${isInCompare ? '#1a1a1a' : '#e5e7eb'}; border-radius: 4px; overflow: hidden; transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease; box-shadow: ${isInCompare ? '0 0 0 1px #1a1a1a' : '0 1px 3px rgba(0,0,0,0.06)'}; display: flex; flex-direction: column;">
  
            <button onclick="event.preventDefault(); showQuickView('${product.id}')" style="position: absolute; top: ${group.isCanadian ? '48px' : '8px'}; right: 8px; background: white; border: none; border-radius: 50%; width: 36px; height: 36px; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 8px rgba(0,0,0,0.1); opacity: 0; transition: opacity 0.2s; z-index: 1;" class="quick-view-btn product-icon-btn" data-tooltip="Quick View">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <span class="icon-tooltip">Quick View</span>
            </button>
  
            <a href="${productUrl}" data-elevar-product-id="${product.id}" onclick="if(window.MeiliAnalytics) MeiliAnalytics.trackClick('', '${product.id}', '', ${index + 1}, 'collection-page');" style="text-decoration: none; color: inherit; display: block;">
              <div style="position: relative; background: white; overflow: hidden; padding: 5px;">
                ${group.hasOnSale ? `
                  <div style="position: absolute; top: 10px; left: 10px; background: #dc2626; color: white; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; z-index: 1;">SALE</div>
                ` : ''}
                ${group.isNewArrival ? `
                  <div style="position: absolute; top: ${group.hasOnSale ? '40px' : '10px'}; left: 10px; background: #2563eb; color: white; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; z-index: 1;">NEW</div>
                ` : ''}
                ${group.hasGwpPromo ? `
                  <div style="position: absolute; top: ${group.hasOnSale && group.isNewArrival ? '70px' : group.hasOnSale || group.isNewArrival ? '40px' : '10px'}; left: 10px; background: #059669; color: white; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; z-index: 1;">FREE GIFT</div>
                ` : ''}
                ${group.hasPromo && !group.hasOnSale && !group.hasGwpPromo ? `
                  <div style="position: absolute; top: ${group.isNewArrival ? '40px' : '10px'}; left: 10px; background: #2563eb; color: white; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; z-index: 1;">PROMO</div>
                ` : ''}
                ${group.isCanadian ? `
                  <div style="position: absolute; top: 10px; right: 10px; z-index: 1;" title="Canadian Brand">
                    <svg width="28" height="28" viewBox="0 0 512 512" fill="#dc2626"><path d="M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"/></svg>
                  </div>
                ` : ''}
                ${imageUrl ? `
                  <img src="${escapeHtml(shopifyImageUrl(imageUrl, 300))}"
                       srcset="${shopifyImageSrcset(imageUrl, [200, 300, 450])}"
                       sizes="(max-width: 479px) 45vw, (max-width: 767px) 30vw, 25vw"
                       alt="${safeTitle}" width="300" height="300" ${imgPriority}
                       style="width: 100%; height: auto; display: block; aspect-ratio: 1; object-fit: contain;" class="product-card-image">
                ` : `
                  <div style="width: 100%; aspect-ratio: 1; background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #ddd; font-size: 14px;">No image</div>
                `}
              </div>
              <div class="product-card-content" style="padding: 14px 14px 8px;">
                ${vendor ? `<div style="font-size: 10px; color: #9ca3af; text-transform: uppercase; letter-spacing: 1.2px; margin-bottom: 4px; font-weight: 600;">${vendor}</div>` : ''}
                <h3 style="font-size: 13px; font-weight: 600; line-height: 1.4; margin: 0; color: #111;">${safeTitle}${escapeHtml(colorSuffix)}</h3>
                ${skuHTML}
                <div class="product-price-display" style="margin-top: 8px; font-size: 18px; font-weight: 700; color: #1a1a1a;">${priceHTML}</div>
                ${affirmHTML}
              </div>
            </a>
            ${product.tags && product.tags.includes('dept_bbqs-smokers') ? `<div class="compare-btn-wrap" style="padding: 14px; border-top: 1px solid #e5e7eb; margin-top: auto;">
              <button type="button" onclick="event.preventDefault(); event.stopPropagation(); toggleCompare('${product.id}', ${!isInCompare})" aria-pressed="${isInCompare}" style="display: inline-flex; align-items: center; gap: 8px; background: none; border: none; padding: 0; cursor: pointer; font-size: 14px; color: #1a1a1a; font-weight: 700; text-decoration: none; transition: color 0.15s; line-height: 1;">
                <span aria-hidden="true" style="display: inline-flex; align-items: center; justify-content: center; width: 16px; height: 16px; flex-shrink: 0;">
                  ${isInCompare
                    ? '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#1a1a1a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3,8 7,12 13,4"/></svg>'
                    : '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#1a1a1a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="3" x2="8" y2="13"/><line x1="3" y1="8" x2="13" y2="8"/></svg>'
                  }
                </span>
                ${isInCompare ? 'Added to compare' : 'Add to compare'}
              </button>
            </div>` : `<div class="compare-btn-wrap-placeholder" aria-hidden="true" style="height: 48px; visibility: hidden; margin-top: auto;"></div>`}
          </div>
        `;
      }).join('');
  
      // Refresh Affirm promos on dynamically rendered cards
      if (typeof affirm !== 'undefined' && affirm.ui && affirm.ui.refresh) {
        affirm.ui.refresh();
      }

      // Clear the server-rendered min-height now that JS has taken over.
      // Min-height was only there to prevent CLS during initial paint (when SEO fallback
      // gets replaced by Meilisearch results). Once we render, let the grid match actual content.
      els.resultsGrid.style.minHeight = '0';

      // Elevar dl_view_item_list — disabled, Elevar's SDK handles this automatically

      DEBUG && console.log('✅ Products rendered');
    }
  
    function handleFilterChange(e) {
      const filterType = e.target.dataset.filterType;
      const value = e.target.value;
      const checked = e.target.checked;
  
      if (filterType === 'quick') {
        if (value === 'new-arrival') currentFilters.newArrival = checked;
        else if (value === 'promotion') currentFilters.promotion = checked;
        else if (value === 'clearance') currentFilters.clearance = checked;
        else if (value === 'canadian-brands') currentFilters.canadianBrands = checked;
      } else if (filterType === 'brand') {
        checked ? currentFilters.brands.add(value) : currentFilters.brands.delete(value);
      } else if (filterType === 'taxonomy-configuration') {
        checked ? currentFilters.taxonomy.configuration.add(value) : currentFilters.taxonomy.configuration.delete(value);
      } else if (filterType === 'fuel_type') {
        checked ? currentFilters.fuelTypes.add(value) : currentFilters.fuelTypes.delete(value);
      } else if (filterType === 'type') {
        checked ? currentFilters.types.add(value) : currentFilters.types.delete(value);
      } else if (filterType === 'color') {
        checked ? currentFilters.colors.add(value) : currentFilters.colors.delete(value);
      } else if (filterType === 'series') {
        checked ? currentFilters.series.add(value) : currentFilters.series.delete(value);
      } else if (filterType === 'main-burners') {
        checked ? currentFilters.mainBurners.add(value) : currentFilters.mainBurners.delete(value);
      } else if (filterType === 'side-burners') {
        checked ? currentFilters.sideBurners.add(value) : currentFilters.sideBurners.delete(value);
      } else if (filterType === 'rear-rotisserie') {
        checked ? currentFilters.rearRotisserie.add(value) : currentFilters.rearRotisserie.delete(value);
      } else if (filterType === 'product-category') {
        checked ? currentFilters.productCategory.add(value) : currentFilters.productCategory.delete(value);
      } else if (filterType === 'product-type') {
        checked ? currentFilters.productType.add(value) : currentFilters.productType.delete(value);
      } else if (filterType === 'configuration') {
        checked ? currentFilters.configuration.add(value) : currentFilters.configuration.delete(value);
      } else if (filterType === 'availability') {
        checked ? currentFilters.availability.add(value) : currentFilters.availability.delete(value);
      } else if (filterType === 'metafield') {
        const metafieldKey = e.target.dataset.metafieldKey;
        if (!currentFilters.metafields[metafieldKey]) currentFilters.metafields[metafieldKey] = new Set();
        checked ? currentFilters.metafields[metafieldKey].add(value) : currentFilters.metafields[metafieldKey].delete(value);
      }
  
      updateClearButton();
      currentPage = 1;
      performSearch();
    }
  
    window.loadMore = function() {
      performSearch(true);
    };
  
    function updateClearButton() {
      const hasMetafieldFilters = Object.values(currentFilters.metafields).some(set => set && set.size > 0);
      const hasFilters = currentFilters.brands.size > 0 || currentFilters.types.size > 0 || currentFilters.colors.size > 0 || currentFilters.fuelTypes.size > 0 || currentFilters.taxonomy.configuration.size > 0 || currentFilters.series.size > 0 || currentFilters.mainBurners.size > 0 || currentFilters.sideBurners.size > 0 || currentFilters.rearRotisserie.size > 0 || currentFilters.productCategory.size > 0 || currentFilters.productType.size > 0 || currentFilters.configuration.size > 0 || currentFilters.availability.size > 0 || currentFilters.priceMin !== null || currentFilters.priceMax !== null || currentFilters.newArrival || currentFilters.promotion || currentFilters.clearance || currentFilters.canadianBrands || hasMetafieldFilters;
      els.clearAll.style.display = hasFilters ? 'block' : 'none';
      updateActiveFilterPills();
    }
  
    function updateActiveFilterPills() {
      const pills = [];
  
      if (currentFilters.newArrival) pills.push({ type: 'new-arrival', value: 'true', label: 'New Arrivals' });
      if (currentFilters.promotion) pills.push({ type: 'promotion', value: 'true', label: 'Promotion' });
      if (currentFilters.clearance) pills.push({ type: 'clearance', value: 'true', label: 'Clearance' });
      if (currentFilters.canadianBrands) pills.push({ type: 'canadian-brands', value: 'true', label: 'Canadian Brands' });
  
      currentFilters.brands.forEach(brand => pills.push({ type: 'brand', value: brand, label: brand }));
      currentFilters.taxonomy.configuration.forEach(v => pills.push({ type: 'taxonomy-configuration', value: v, label: `Config: ${v}` }));
      currentFilters.fuelTypes.forEach(f => pills.push({ type: 'fuel_type', value: f, label: `Fuel: ${f}` }));
      currentFilters.types.forEach(type => pills.push({ type: 'type', value: type, label: type }));
      currentFilters.series.forEach(s => pills.push({ type: 'series', value: s, label: `Series: ${s}` }));
      currentFilters.mainBurners.forEach(m => pills.push({ type: 'main-burners', value: m, label: `Main Burners: ${m}` }));
      currentFilters.sideBurners.forEach(s => pills.push({ type: 'side-burners', value: s, label: `Side Burners: ${s}` }));
      currentFilters.rearRotisserie.forEach(r => pills.push({ type: 'rear-rotisserie', value: r, label: `Rear/Rotisserie: ${r}` }));
      currentFilters.productCategory.forEach(v => pills.push({ type: 'product-category', value: v, label: v }));
      currentFilters.productType.forEach(v => pills.push({ type: 'product-type', value: v, label: v }));
      currentFilters.configuration.forEach(v => pills.push({ type: 'configuration', value: v, label: `Config: ${v}` }));
      currentFilters.availability.forEach(v => pills.push({ type: 'availability', value: v, label: v }));
      currentFilters.colors.forEach(color => pills.push({ type: 'color', value: color, label: color }));
  
      if (currentFilters.priceMin !== null && currentFilters.priceMin > 0) {
        pills.push({ type: 'price-min', value: currentFilters.priceMin, label: `Min: $${currentFilters.priceMin}` });
      }
      if (currentFilters.priceMax !== null && currentFilters.priceMax > 0) {
        pills.push({ type: 'price-max', value: currentFilters.priceMax, label: `Max: $${currentFilters.priceMax}` });
      }
  
      // Metafield filter pills
      Object.entries(currentFilters.metafields).forEach(([metafieldKey, values]) => {
        if (values && values.size > 0) {
          const fc = window.filterConfig?.metafieldFilters?.find(f => f.filterKey === metafieldKey);
          const displayName = metafieldKey === 'custom.sale_offer_name'
            ? 'Offer'
            : (fc?.displayName || metafieldKey.split('.').pop());
          values.forEach(value => pills.push({ type: 'metafield', value: value, metafieldKey: metafieldKey, label: `${displayName}: ${value}` }));
        }
      });
  
      if (pills.length === 0) {
        els.activeFilters.style.display = 'none';
        return;
      }
  
      els.activeFilters.style.display = 'flex';
      els.activeFilters.innerHTML = pills.map(pill => {
        const safeValue = escapeHtml(String(pill.value));
        const safeLabel = escapeHtml(pill.label);
        const safeMetafieldKey = pill.metafieldKey ? escapeHtml(pill.metafieldKey) : '';
        const removeArgs = pill.type === 'metafield'
          ? `'${pill.type}', '${safeValue}', '${safeMetafieldKey}'`
          : `'${pill.type}', '${safeValue}'`;
        return `
        <span style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 10px; background: #f3f4f6; border: 1px solid #d1d5db; border-radius: 4px; font-size: 13px; color: #1a1a1a; font-weight: 400;">
          ${safeLabel}
          <button onclick="removeFilter(${removeArgs})" style="background: none; border: none; padding: 0; margin-left: 2px; cursor: pointer; display: flex; align-items: center; color: #6b7280; transition: color 0.2s; line-height: 1;" title="Remove filter" onmouseover="this.style.color='#1a1a1a'" onmouseout="this.style.color='#6b7280'">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <path d="M3 3l6 6M9 3l-6 6"/>
            </svg>
          </button>
        </span>
      `}).join('');
  
      if (pills.length > 0) {
        els.activeFilters.innerHTML += `
          <button onclick="document.getElementById('clear-all-filters').click()" style="padding: 6px 12px; background: none; border: 1px solid #e5e7eb; color: #6b7280; font-size: 13px; font-weight: 400; cursor: pointer; border-radius: 4px; transition: all 0.2s;" onmouseover="this.style.borderColor='#1a1a1a'; this.style.color='#1a1a1a'" onmouseout="this.style.borderColor='#e5e7eb'; this.style.color='#6b7280'">
            Clear filters
          </button>
        `;
      }
    }
  
    window.removeFilter = function(type, value, metafieldKey) {
      if (type === 'brand') {
        currentFilters.brands.delete(value);
      } else if (type === 'type') {
        currentFilters.types.delete(value);
      } else if (type === 'color') {
        currentFilters.colors.delete(value);
      } else if (type === 'fuel_type') {
        currentFilters.fuelTypes.delete(value);
      } else if (type === 'taxonomy-configuration') {
        currentFilters.taxonomy.configuration.delete(value);
      } else if (type === 'series') {
        currentFilters.series.delete(value);
      } else if (type === 'main-burners') {
        currentFilters.mainBurners.delete(value);
      } else if (type === 'side-burners') {
        currentFilters.sideBurners.delete(value);
      } else if (type === 'rear-rotisserie') {
        currentFilters.rearRotisserie.delete(value);
      } else if (type === 'product-category') {
        currentFilters.productCategory.delete(value);
      } else if (type === 'product-type') {
        currentFilters.productType.delete(value);
      } else if (type === 'configuration') {
        currentFilters.configuration.delete(value);
      } else if (type === 'availability') {
        currentFilters.availability.delete(value);
      } else if (type === 'metafield' && metafieldKey) {
        if (currentFilters.metafields[metafieldKey]) {
          currentFilters.metafields[metafieldKey].delete(value);
        }
      } else if (type === 'price-min') {
        currentFilters.priceMin = null;
        els.priceMin.value = '';
        if (els.priceSliderMin) els.priceSliderMin.value = 0;
        updatePriceSliderRange();
      } else if (type === 'price-max') {
        currentFilters.priceMax = null;
        els.priceMax.value = '';
        if (els.priceSliderMax) els.priceSliderMax.value = 10000;
        updatePriceSliderRange();
      } else if (type === 'new-arrival') {
        currentFilters.newArrival = false;
        if (els.newArrivalToggle) els.newArrivalToggle.checked = false;
      } else if (type === 'promotion') {
        currentFilters.promotion = false;
        if (els.promotionToggle) els.promotionToggle.checked = false;
      } else if (type === 'clearance') {
        currentFilters.clearance = false;
        if (els.clearanceToggle) els.clearanceToggle.checked = false;
      } else if (type === 'canadian-brands') {
        currentFilters.canadianBrands = false;
        if (els.canadianBrandsToggle) els.canadianBrandsToggle.checked = false;
      }
      updateClearButton();
      currentPage = 1;
      performSearch();
    };
  
    // Price slider logic (initialized after dynamic filter rendering)
    let priceTimeout;
    let priceSliderListenersAttached = false;
  
    function updatePriceSliderRange() {
      if (!els.priceSliderMin || !els.priceSliderMax || !els.priceSliderRange) return;
  
      const minVal = parseInt(els.priceSliderMin.value);
      const maxVal = parseInt(els.priceSliderMax.value);
      const rangeMax = 10000;
  
      const minPercent = (minVal / rangeMax) * 100;
      const maxPercent = (maxVal / rangeMax) * 100;
  
      els.priceSliderRange.style.left = minPercent + '%';
      els.priceSliderRange.style.right = (100 - maxPercent) + '%';
    }
  
    function attachPriceSliderListeners() {
      if (priceSliderListenersAttached) {
        DEBUG && console.log('💰 [PRICE DEBUG] attachPriceSliderListeners SKIPPED — already attached');
        return;
      }
      if (!els.priceMin || !els.priceMax || !els.priceSliderMin || !els.priceSliderMax) {
        DEBUG && console.log('💰 [PRICE DEBUG] attachPriceSliderListeners SKIPPED — missing elements:', {
          priceMin: !!els.priceMin, priceMax: !!els.priceMax,
          sliderMin: !!els.priceSliderMin, sliderMax: !!els.priceSliderMax
        });
        return;
      }
  
      priceSliderListenersAttached = true;
      DEBUG && console.log('💰 [PRICE DEBUG] ✅ Price listeners attached to elements:', els.priceMin.id, els.priceMax.id);
  
      els.priceMin.addEventListener('input', () => {
        clearTimeout(priceTimeout);
        const val = parseFloat(els.priceMin.value);
        DEBUG && console.log('💰 [PRICE DEBUG] Min input fired, raw value:', els.priceMin.value, '→ parsed:', val);
        if (val >= 0) {
          els.priceSliderMin.value = val;
          updatePriceSliderRange();
        }
        priceTimeout = setTimeout(() => {
          currentFilters.priceMin = val > 0 ? val : null;
          DEBUG && console.log('💰 [PRICE DEBUG] Min filter set to:', currentFilters.priceMin);
          updateClearButton();
          currentPage = 1;
          performSearch();
        }, 500);
      });
  
      els.priceMax.addEventListener('input', () => {
        clearTimeout(priceTimeout);
        const val = parseFloat(els.priceMax.value);
        DEBUG && console.log('💰 [PRICE DEBUG] Max input fired, raw value:', els.priceMax.value, '→ parsed:', val);
        if (val >= 0) {
          els.priceSliderMax.value = val;
          updatePriceSliderRange();
        }
        priceTimeout = setTimeout(() => {
          currentFilters.priceMax = val > 0 ? val : null;
          DEBUG && console.log('💰 [PRICE DEBUG] Max filter set to:', currentFilters.priceMax);
          updateClearButton();
          currentPage = 1;
          performSearch();
        }, 500);
      });
  
      els.priceSliderMin.addEventListener('input', () => {
        let minVal = parseInt(els.priceSliderMin.value);
        let maxVal = parseInt(els.priceSliderMax.value);
  
        if (minVal > maxVal - 100) {
          minVal = maxVal - 100;
          els.priceSliderMin.value = minVal;
        }
  
        els.priceMin.value = minVal;
        updatePriceSliderRange();
  
        clearTimeout(priceTimeout);
        priceTimeout = setTimeout(() => {
          currentFilters.priceMin = minVal > 0 ? minVal : null;
          updateClearButton();
          currentPage = 1;
          performSearch();
        }, 500);
      });
  
      els.priceSliderMax.addEventListener('input', () => {
        let minVal = parseInt(els.priceSliderMin.value);
        let maxVal = parseInt(els.priceSliderMax.value);
  
        if (maxVal < minVal + 100) {
          maxVal = minVal + 100;
          els.priceSliderMax.value = maxVal;
        }
  
        els.priceMax.value = maxVal;
        updatePriceSliderRange();
  
        clearTimeout(priceTimeout);
        priceTimeout = setTimeout(() => {
          currentFilters.priceMax = maxVal < 10000 ? maxVal : null;
          updateClearButton();
          currentPage = 1;
          performSearch();
        }, 500);
      });
  
      updatePriceSliderRange();
    }
  
    els.sortSelect.addEventListener('change', (e) => {
      currentSort = e.target.value;
      userChangedSort = true; // User explicitly changed sort
      currentPage = 1;
      performSearch();
      // Sync mobile dropdown
      const mobileSort = document.getElementById('mobile-sort-select');
      if (mobileSort) mobileSort.value = currentSort;
    });
  
    // Mobile sort handler — called directly from mobile dropdown
    window.handleMobileSort = function(value) {
      currentSort = value;
      userChangedSort = true;
      currentPage = 1;
      performSearch();
      // Sync desktop dropdown
      if (els.sortSelect) els.sortSelect.value = value;
    };
  
    els.sortSelect.value = currentSort;
  
    // Checkbox filter event listeners (null-safe — not all types have all checkboxes)
    if (els.newArrivalToggle) { els.newArrivalToggle.addEventListener('change', handleFilterChange); els.newArrivalToggle.checked = currentFilters.newArrival; }
    if (els.promotionToggle) { els.promotionToggle.addEventListener('change', handleFilterChange); els.promotionToggle.checked = currentFilters.promotion; }
    if (els.clearanceToggle) { els.clearanceToggle.addEventListener('change', handleFilterChange); els.clearanceToggle.checked = currentFilters.clearance; }
    if (els.canadianBrandsToggle) { els.canadianBrandsToggle.addEventListener('change', handleFilterChange); els.canadianBrandsToggle.checked = currentFilters.canadianBrands; }
  
    els.clearAll.addEventListener('click', (e) => {
      e.preventDefault();
      currentFilters.brands.clear();
      currentFilters.types.clear();
      currentFilters.colors.clear();
      currentFilters.fuelTypes.clear();
      currentFilters.priceMin = null;
      currentFilters.priceMax = null;
      currentFilters.newArrival = false;
      currentFilters.promotion = false;
      currentFilters.clearance = false;
      currentFilters.canadianBrands = false;
      currentFilters.taxonomy.configuration.clear();
      currentFilters.series.clear();
      currentFilters.mainBurners.clear();
      currentFilters.sideBurners.clear();
      currentFilters.rearRotisserie.clear();
      currentFilters.productCategory.clear();
      currentFilters.productType.clear();
      currentFilters.configuration.clear();
      currentFilters.availability.clear();
      // Clear all metafield filters
      Object.keys(currentFilters.metafields).forEach(key => {
        currentFilters.metafields[key].clear();
      });
      els.priceMin.value = '';
      els.priceMax.value = '';
      if (els.newArrivalToggle) els.newArrivalToggle.checked = false;
      if (els.promotionToggle) els.promotionToggle.checked = false;
      if (els.clearanceToggle) els.clearanceToggle.checked = false;
      if (els.canadianBrandsToggle) els.canadianBrandsToggle.checked = false;
      if (els.priceSliderMin) els.priceSliderMin.value = 0;
      if (els.priceSliderMax) els.priceSliderMax.value = 10000;
      updatePriceSliderRange();
      updateClearButton();
      currentPage = 1;
      performSearch();
    });
  
    function isMobileDrawerOpen() {
      const sidebar = document.getElementById('collection-filters');
      return sidebar && sidebar.style.transform === 'translateX(0%)';
    }
  
    function showLoading() {
      // Don't show loading skeleton while mobile filter drawer is open
      if (isMobileDrawerOpen()) return;
      els.loading.style.display = 'grid';
      els.noResults.style.display = 'none';
      els.resultsGrid.innerHTML = '';
      // Keep results header visible if filters are active (so user can clear them)
      if (!hasAnyActiveFilters()) {
        els.resultsHeader.style.display = 'none';
      }
    }
  
    function hasAnyActiveFilters() {
      const hasMetafieldFilters = Object.values(currentFilters.metafields).some(set => set && set.size > 0);
      return currentFilters.brands.size > 0 || currentFilters.types.size > 0 || currentFilters.colors.size > 0 || currentFilters.fuelTypes.size > 0 || currentFilters.taxonomy.configuration.size > 0 || currentFilters.series.size > 0 || currentFilters.mainBurners.size > 0 || currentFilters.sideBurners.size > 0 || currentFilters.rearRotisserie.size > 0 || currentFilters.priceMin !== null || currentFilters.priceMax !== null || currentFilters.newArrival || currentFilters.promotion || currentFilters.clearance || currentFilters.canadianBrands || hasMetafieldFilters;
    }
  
    function hideLoading() {
      els.loading.style.display = 'none';
    }
  
    function showNoResults() {
      DEBUG && console.log('🚫 [DEBUG] showNoResults() called. hasAnyActiveFilters:', hasAnyActiveFilters());
      hideLoading();
      // Clear the product grid (showLoading may have been skipped if mobile drawer was open)
      els.resultsGrid.innerHTML = '';
      els.resultsGrid.style.minHeight = '0';
      // Restore no-results content (showError may have overwritten it)
      els.noResults.innerHTML = `
        <h2 style="font-size: 24px; margin-bottom: 12px; font-weight: 600;">No Products Found</h2>
        <p style="color: #999; font-size: 15px;">Try adjusting your filters</p>
        ${hasAnyActiveFilters() ? `<button onclick="document.getElementById('clear-all-filters').click()" style="margin-top: 16px; padding: 10px 24px; background: #1a1a1a; color: white; border: none; border-radius: 4px; font-size: 14px; font-weight: 600; cursor: pointer;">Clear All Filters</button>` : ''}
      `;
      els.noResults.style.display = 'block';
      els.resultsHeader.style.display = 'block';
      // Update count to show 0 products
      els.resultsCount.innerHTML = `<span style="font-weight: 600;">${collectionTitle}</span> <span style="color: #666; font-weight: 400;">0 products</span>`;
      // Update mobile product count
      const mobileCount = document.getElementById('mobile-product-count');
      if (mobileCount) mobileCount.textContent = '0 Products';
      // Update mobile view products button
      const viewProductsBtn = document.getElementById('view-products-btn');
      if (viewProductsBtn) viewProductsBtn.textContent = 'VIEW 0 PRODUCTS';
      updateClearButton();
      document.getElementById('load-more-container').style.display = 'none';
    }
  
    function showError(error) {
      hideLoading();
      els.resultsGrid.style.minHeight = '0';
      // If Meilisearch is unreachable (network error or 5xx), fall back to Shopify native collection
      const isServerDown = !error.httpStatus || error.httpStatus >= 500 || error.message === 'Failed to fetch' || (error.name === 'TypeError' && error.message.includes('fetch'));
      if (isServerDown) {
        els.noResults.innerHTML = `
          <div style="text-align: center; padding: 40px 20px;">
            <h2 style="font-size: 22px; margin-bottom: 12px;">Loading products...</h2>
            <p style="color: #666; margin-bottom: 20px;">Switching to standard view.</p>
          </div>
        `;
        els.noResults.style.display = 'block';
        // Redirect to Shopify's native collection page (uses collection.json template)
        const nativeUrl = window.location.pathname + '?view=original';
        setTimeout(function() { window.location.href = nativeUrl; }, 1500);
      } else {
        els.noResults.innerHTML = `
          <h2 style="font-size: 24px; margin-bottom: 12px;">Error Loading Collection</h2>
          <p style="color: #999;">Please try again later.</p>
        `;
        els.noResults.style.display = 'block';
      }
      document.getElementById('load-more-container').style.display = 'none';
    }
  
    window.switchCardColor = function(swatch, imageUrl) {
      const card = swatch.closest('.product-card');
      if (!card) return;
  
      // Swap image
      if (imageUrl) {
        const img = card.querySelector('.product-card-image');
        if (img) {
          img.src = imageUrl;
        }
      }
  
      // Update active swatch state
      card.querySelectorAll('.color-swatch').forEach(s => {
        s.classList.remove('active');
        s.style.boxShadow = 'none';
      });
      swatch.classList.add('active');
      swatch.style.boxShadow = '0 0 0 2px white, 0 0 0 3.5px #1a1a1a';
    };
  
    window.toggleFilterSection = function(section) {
      const optionsDiv = document.getElementById(`${section}-filter-options`);
      const arrow = document.getElementById(`${section}-arrow`);
  
      if (optionsDiv.style.display === 'none') {
        optionsDiv.style.display = 'block';
        arrow.style.transform = 'rotate(180deg)';
      } else {
        optionsDiv.style.display = 'none';
        arrow.style.transform = 'rotate(0deg)';
      }
      optionsDiv.setAttribute('aria-expanded', optionsDiv.style.display !== 'none');
    };
  
    window.toggleMobileFilters = function() {
      const sidebar = document.getElementById('collection-filters');
      const overlay = document.getElementById('mobile-filter-overlay');
      const isOpen = sidebar.style.transform === 'translateX(0%)';
  
      if (isOpen) {
        sidebar.style.transform = 'translateX(-100%)';
        if (overlay) overlay.classList.remove('active');
        document.body.style.overflow = '';
      } else {
        sidebar.style.transform = 'translateX(0%)';
        if (overlay) overlay.classList.add('active');
        document.body.style.overflow = 'clip';
        trapFocus(sidebar);
      }
    };
  
    window.closeMobileFilters = function() {
      const sidebar = document.getElementById('collection-filters');
      const overlay = document.getElementById('mobile-filter-overlay');
      sidebar.style.transform = 'translateX(-100%)';
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    };
  
    window.showQuickView = function(productId) {
      const product = allProducts.find(p => p.id === productId);
      if (!product) return;
  
      DEBUG && console.log('Quick View product data:', product);
      DEBUG && console.log('variant_id:', product.variant_id);
  
      // Price display
      const hasDiscount = product.compare_at_price && product.compare_at_price > product.price;
      const priceHtml = hasDiscount
        ? `<div style="display: flex; align-items: baseline; gap: 12px; margin-bottom: 20px;">
             <span style="font-size: 32px; font-weight: 700; color: #dc2626;">$${formatPrice(product.price)}</span>
             <span style="font-size: 20px; color: #9ca3af; text-decoration: line-through;">$${formatPrice(product.compare_at_price)}</span>
           </div>`
        : `<div style="font-size: 32px; font-weight: 700; color: #1a1a1a; margin-bottom: 20px;">$${formatPrice(product.price)}</div>`;
  
      // Product metadata (plain text, no background)
      const metadataItems = [];
      if (product.sku) metadataItems.push(`<div style="font-size: 13px; color: #6b7280; margin-bottom: 12px;"><strong style="color: #4b5563;">SKU:</strong> ${escapeHtml(product.sku)}</div>`);
      if (product['general_specs.series']) metadataItems.push(`<div style="font-size: 13px; color: #6b7280; margin-bottom: 12px;"><strong style="color: #4b5563;">Series:</strong> ${escapeHtml(product['general_specs.series'])}</div>`);
  
      // Show variant info using actual option names, with fallback to direct fields
      const qvOptionParts = [];
      for (let i = 1; i <= 3; i++) {
        const optName = product[`option${i}_name`];
        const optVal = product[`option${i}_value`];
        if (optName && optVal) {
          qvOptionParts.push(`<strong style="color: #4b5563;">${escapeHtml(optName)}:</strong> ${escapeHtml(optVal)}`);
        }
      }
      // Fall back to direct fields if no option fields found
      if (qvOptionParts.length === 0) {
        if (product.color) qvOptionParts.push(`<strong style="color: #4b5563;">Color:</strong> ${escapeHtml(product.color)}`);
        if (product.fuel_type) qvOptionParts.push(`<strong style="color: #4b5563;">Fuel Type:</strong> ${escapeHtml(product.fuel_type)}`);
        if (product.size) qvOptionParts.push(`<strong style="color: #4b5563;">Size:</strong> ${escapeHtml(product.size)}`);
        if (product.material) qvOptionParts.push(`<strong style="color: #4b5563;">Material:</strong> ${escapeHtml(product.material)}`);
      }
      if (qvOptionParts.length > 0) {
        metadataItems.push(`<div style="font-size: 13px; color: #6b7280; margin-bottom: 12px;">${qvOptionParts.join(' <span style="color: #d1d5db; margin: 0 8px;">|</span> ')}</div>`);
      }
  
      const metadataHtml = metadataItems.join('');
  
      // Clean the title - remove variant suffix like " - Propane/Natural Gas / Color"
      let cleanTitle = escapeHtml(product.full_title || product.title);
      cleanTitle = cleanTitle.replace(/\s*-\s*(Propane\/Natural Gas|Natural Gas\/Propane|Propane|Natural Gas)\s*\/\s*[\w\s]+$/i, '');
      cleanTitle = cleanTitle.replace(/\s*-\s*(Propane\/Natural Gas|Natural Gas\/Propane)$/i, '');
  
      const modal = document.getElementById('quick-view-modal');
      modal.innerHTML = `
        <div class="quick-view-overlay" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.75); z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 20px; animation: fadeIn 0.2s ease-out;" onclick="closeQuickView()">
          <div class="quick-view-content" role="dialog" aria-modal="true" aria-label="Quick View" style="background: white; border-radius: 8px; max-width: 1000px; width: 100%; max-height: 90vh; overflow: hidden; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25); animation: slideUp 0.3s ease-out;" onclick="event.stopPropagation()">
            <div style="position: sticky; top: 0; background: white; border-bottom: 1px solid #e7e7e7; padding: 24px 32px; display: flex; justify-content: space-between; align-items: center; z-index: 10;">
              <h2 style="font-size: 20px; font-weight: 700; margin: 0; color: #111827;">Quick View</h2>
              <button onclick="closeQuickView()" style="background: #f3f4f6; border: none; padding: 10px; cursor: pointer; color: #6b7280; border-radius: 8px; transition: all 0.2s; display: flex; align-items: center; justify-content: center;" onmouseover="this.style.background='#e5e7eb'; this.style.color='#111827';" onmouseout="this.style.background='#f3f4f6'; this.style.color='#6b7280';" title="Close">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                  <path d="M6 6l12 12M18 6l-12 12"/>
                </svg>
              </button>
            </div>
            <div style="padding: 40px; display: grid; grid-template-columns: 1fr 1fr; gap: 48px; overflow-y: auto; max-height: calc(90vh - 80px);">
              <div>
                <div style="background: #f9fafb; border-radius: 12px; overflow: hidden; aspect-ratio: 1/1; display: flex; align-items: center; justify-content: center;">
                  <img src="${escapeHtml(shopifyImageUrl(product.image_url || '', 600))}"
                       srcset="${shopifyImageSrcset(product.image_url || '', [400, 600, 800])}"
                       sizes="(max-width: 768px) 90vw, 45vw"
                       alt="${cleanTitle}" style="width: 100%; height: 100%; object-fit: contain;">
                </div>
              </div>
              <div style="display: flex; flex-direction: column;">
                ${product.vendor ? `<div style="font-size: 12px; color: #6b7280; text-transform: uppercase; letter-spacing: 1.2px; margin-bottom: 12px; font-weight: 700;">${escapeHtml(product.vendor)}</div>` : ''}
                <h3 style="font-size: 28px; font-weight: 700; margin: 0 0 20px; line-height: 1.2; color: #111827;">${cleanTitle}</h3>
                ${priceHtml}
                ${metadataHtml}
                <div style="color: #4b5563; line-height: 1.7; margin-bottom: 28px; font-size: 15px;">${product.description ? sanitizeHtml(product.description) : 'No description available.'}</div>
                <div style="margin-top: auto; padding-top: 20px; border-top: 1px solid #e7e7e7; display: flex; flex-direction: column; gap: 12px;">
                  <a href="${product.url}" style="display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 16px 32px; background: #000000; color: white; text-decoration: none; border-radius: 4px; font-weight: 700; font-size: 15px; transition: all 0.2s; box-shadow: 0 2px 4px rgba(0,0,0,0.1);" onmouseover="this.style.background='#1a1a1a'; this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 8px rgba(0,0,0,0.15)';" onmouseout="this.style.background='#000000'; this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(0,0,0,0.1)';">
                    View Full Details
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </a>
                  <button onclick="${product.variant_count > 1 ? `window.location.href='${product.url}'` : `buyNow('${product.variant_id}')`}" style="display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 16px 32px; background: #2183DF; color: white; border: none; border-radius: 4px; font-weight: 700; font-size: 15px; cursor: pointer; transition: all 0.2s; box-shadow: 0 2px 4px rgba(0,0,0,0.1);" onmouseover="this.style.background='#1a6fc2'; this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 8px rgba(0,0,0,0.15)';" onmouseout="this.style.background='#2183DF'; this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(0,0,0,0.1)';">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="9" cy="21" r="1"></circle>
                      <circle cx="20" cy="21" r="1"></circle>
                      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                    </svg>
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      modal.style.display = 'block';
      document.body.style.overflow = 'clip';
  
      // Add CSS animations
      const style = document.createElement('style');
      style.textContent = `
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (max-width: 768px) {
          .quick-view-content > div:last-child {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
            padding: 24px !important;
          }
        }
      `;
      if (!document.getElementById('quick-view-animations')) {
        style.id = 'quick-view-animations';
        document.head.appendChild(style);
      }
    };
  
    window.closeQuickView = function() {
      const modal = document.getElementById('quick-view-modal');
      modal.style.display = 'none';
      modal.innerHTML = '';
      document.body.style.overflow = '';
    };
  
    window.buyNow = async function(variantId) {
      DEBUG && console.log('Buy Now clicked, variantId:', variantId);
  
      // Handle undefined/null/empty variant IDs
      if (!variantId || variantId === 'undefined' || variantId === 'null' || variantId === '') {
        alert('Unable to add to cart. This product requires variant selection - please view the full product page.');
        return;
      }
  
      const btn = event.target.closest('button');
      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke-dasharray="32" stroke-dashoffset="12"></circle></svg> Processing...';
  
      try {
        // Ensure variant ID is sent as a number (Shopify expects numeric ID)
        const numericVariantId = parseInt(variantId, 10);
        if (isNaN(numericVariantId)) {
          throw new Error('Invalid variant ID');
        }
  
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: numericVariantId, quantity: 1 })
        });
  
        if (response.ok) {
          window.location.href = '/checkout';
        } else {
          const error = await response.json();
          DEBUG && console.error('Cart add error:', error);
          alert(error.description || 'Unable to add to cart');
          btn.disabled = false;
          btn.innerHTML = originalText;
        }
      } catch (error) {
        DEBUG && console.error('Buy now error:', error);
        alert('Something went wrong. Please try again.');
        btn.disabled = false;
        btn.innerHTML = originalText;
      }
    };
  
    // Product Comparison Functions
    const variantCache = new Map();
    let modalCompareState = null;

    function extractHandleFromUrl(url) {
      if (!url) return '';
      const match = String(url).match(/\/products\/([^?#\/]+)/);
      return match ? match[1] : '';
    }

    function buildVariantLabel(variant) {
      const parts = [];
      for (let i = 1; i <= 3; i++) {
        const name = variant['option' + i + '_name'];
        const val = variant['option' + i + '_value'];
        if (val && val !== 'Default Title' && !(name === 'Title' && val === 'Default Title')) {
          parts.push(val);
        }
      }
      if (parts.length) return parts.join(' / ');
      if (variant.variant_title && variant.variant_title !== 'Default Title') {
        return variant.variant_title;
      }
      return 'Default';
    }

    async function loadVariantsForHandle(handle) {
      if (!handle) return [];
      if (variantCache.has(handle)) return variantCache.get(handle);
      try {
        // Search by handle text, then filter client-side for exact handle match.
        // (Direct filter on `handle` requires it to be a Meilisearch filterable attribute.)
        const searchTerm = handle.replace(/-/g, ' ');
        const response = await index.search(searchTerm, { limit: 100 });
        const hits = (response.hits || []).filter(h => h.handle === handle);
        variantCache.set(handle, hits);
        return hits;
      } catch (e) {
        DEBUG && console.error('Failed to load variants for', handle, e);
        return [];
      }
    }

    window.toggleCompare = function(productId, checked) {
      if (checked) {
        if (compareProducts.size >= MAX_COMPARE) {
          alert(`You can only compare up to ${MAX_COMPARE} products at a time.`);
          displayResults(allProducts);
          return;
        }
        compareProducts.add(productId);
      } else {
        compareProducts.delete(productId);
      }
      localStorage.setItem('compareProducts', JSON.stringify([...compareProducts]));
      updateCompareBar();
      displayResults(allProducts);
    };
  
    function updateCompareBar() {
      let compareBar = document.getElementById('compare-bar');
  
      // Prune compare IDs that aren't in current results (e.g. from a different page)
      if (allProducts.length > 0) {
        const availableIds = new Set(allProducts.map(p => p.id));
        const staleIds = [...compareProducts].filter(id => !availableIds.has(id));
        staleIds.forEach(id => compareProducts.delete(id));
        if (staleIds.length > 0) {
          localStorage.setItem('compareProducts', JSON.stringify([...compareProducts]));
        }
      }
  
      if (compareProducts.size === 0) {
        if (compareBar) compareBar.remove();
        return;
      }
  
      if (!compareBar) {
        compareBar = document.createElement('div');
        compareBar.id = 'compare-bar';
        document.body.appendChild(compareBar);
      }
  
      const selectedProducts = allProducts.filter(p => compareProducts.has(p.id));
  
      compareBar.innerHTML = `
        <div style="position: fixed; bottom: 0; left: 0; right: 0; background: white; border-top: 2px solid #1a1a1a; box-shadow: 0 -4px 12px rgba(0,0,0,0.15); z-index: 1000; padding: 16px 20px;">
          <div style="max-width: none; overflow-x: hidden; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap;">
            <div style="display: flex; align-items: center; gap: 16px; flex: 1; overflow-x: auto;">
              <div style="font-size: 14px; font-weight: 600; color: #1a1a1a; white-space: nowrap;">
                Compare (${compareProducts.size}/${MAX_COMPARE})
              </div>
              <div style="display: flex; gap: 10px; overflow-x: auto; flex: 1;">
                ${selectedProducts.map(p => `
                  <div style="display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 6px; white-space: nowrap;">
                    <img src="${escapeHtml(shopifyImageUrl(p.image_url || '', 80))}" alt="" style="width: 40px; height: 40px; object-fit: contain; border-radius: 4px; background: white;">
                    <span style="font-size: 13px; color: #1a1a1a; max-width: 120px; overflow: hidden; text-overflow: ellipsis; font-weight: 500;">${escapeHtml(p.full_title || '')}</span>
                    <button onclick="toggleCompare('${p.id}', false)" style="background: none; border: none; padding: 4px; cursor: pointer; color: #9ca3af; display: flex; align-items: center; transition: color 0.2s;" title="Remove" onmouseover="this.style.color='#1a1a1a'" onmouseout="this.style.color='#9ca3af'">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M4 4l8 8M12 4l-8 8"/>
                      </svg>
                    </button>
                  </div>
                `).join('')}
              </div>
            </div>
            <div style="display: flex; gap: 12px; align-items: center;">
              <button onclick="clearCompare()" style="padding: 10px 18px; background: white; border: 1px solid #d1d5db; color: #6b7280; font-size: 14px; font-weight: 500; cursor: pointer; border-radius: 6px; white-space: nowrap; transition: all 0.2s;"
                      onmouseover="this.style.background='#f9fafb'; this.style.borderColor='#9ca3af';"
                      onmouseout="this.style.background='white'; this.style.borderColor='#d1d5db';">
                Clear All
              </button>
              <button onclick="showCompareModal()" style="padding: 10px 24px; background: #1a1a1a; color: white; border: none; font-size: 14px; font-weight: 600; cursor: pointer; border-radius: 6px; white-space: nowrap; transition: all 0.2s;"
                      onmouseover="this.style.opacity='0.85';"
                      onmouseout="this.style.opacity='1';">
                Compare (${compareProducts.size})
              </button>
            </div>
          </div>
        </div>
      `;
    }
  
    window.clearCompare = function() {
      compareProducts.clear();
      localStorage.setItem('compareProducts', JSON.stringify([]));
      updateCompareBar();
      displayResults(allProducts);
    };
  
  
    window.showCompareModal = async function() {
      const initialProducts = allProducts.filter(p => compareProducts.has(p.id));

      if (initialProducts.length < 2) {
        alert('Please select at least 2 products to compare');
        return;
      }

      // Show loading state
      let loadingModal = document.getElementById('compare-modal');
      if (!loadingModal) {
        loadingModal = document.createElement('div');
        loadingModal.id = 'compare-modal';
        document.body.appendChild(loadingModal);
        document.body.style.overflow = 'clip';
      }
      loadingModal.innerHTML = `
        <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); z-index: 2000; display: flex; align-items: center; justify-content: center;" onclick="closeCompareModal()">
          <div style="background: white; padding: 32px 48px; border-radius: 12px; font-size: 14px; color: #6b7280;">Loading comparison…</div>
        </div>
      `;

      // Load all variants for each compared product in parallel
      const variantsArr = await Promise.all(
        initialProducts.map(p => loadVariantsForHandle(extractHandleFromUrl(p.url)))
      );

      modalCompareState = { products: {}, current: {} };
      initialProducts.forEach((p, idx) => {
        let variants = variantsArr[idx];
        if (!variants || !variants.length) variants = [p];
        if (!variants.find(v => v.id === p.id)) variants = [p].concat(variants);
        modalCompareState.products[p.id] = variants;
        modalCompareState.current[p.id] = p.id;
      });

      renderCompareModal();
    };

    window.changeCompareVariant = function(origId, newVariantId) {
      if (!modalCompareState || !modalCompareState.products[origId]) return;
      modalCompareState.current[origId] = newVariantId;
      renderCompareModal();
    };

    function renderCompareModal() {
      if (!modalCompareState) return;
      const origIds = Object.keys(modalCompareState.current);
      const currentVariants = origIds.map(origId => {
        const variants = modalCompareState.products[origId];
        const currentId = modalCompareState.current[origId];
        return variants.find(v => v.id === currentId) || variants[0];
      });

      let modal = document.getElementById('compare-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.id = 'compare-modal';
        document.body.appendChild(modal);
        document.body.style.overflow = 'clip';
      }

      modal.innerHTML = `
        <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); z-index: 2000; display: flex; align-items: center; justify-content: center; padding: 20px;" onclick="closeCompareModal()">
          <div role="dialog" aria-modal="true" aria-label="Compare Products" style="background: white; border-radius: 12px; max-width: 1400px; width: 100%; max-height: 90vh; overflow: auto; box-shadow: 0 20px 60px rgba(0,0,0,0.3);" onclick="event.stopPropagation()">
            <div style="position: sticky; top: 0; background: white; border-bottom: 1px solid #e5e7eb; padding: 24px; display: flex; justify-content: space-between; align-items: center; z-index: 10; border-radius: 12px 12px 0 0;">
              <h2 style="font-size: 20px; font-weight: 600; margin: 0; color: #1a1a1a;">Product Comparison</h2>
              <button onclick="closeCompareModal()" style="background: none; border: none; padding: 8px; cursor: pointer; color: #9ca3af; display: flex; align-items: center; transition: color 0.2s;" title="Close" onmouseover="this.style.color='#1a1a1a'" onmouseout="this.style.color='#9ca3af'">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M6 6l12 12M18 6l-12 12"/>
                </svg>
              </button>
            </div>
            <div style="padding: 32px; overflow-x: auto;">
              <table style="width: 100%; border-collapse: separate; border-spacing: 0; min-width: 600px;">
                <thead>
                  <tr>
                    <th style="padding: 16px; text-align: left; font-size: 13px; font-weight: 600; color: #9ca3af; background: #ffffff; border-bottom: 2px solid #e5e7eb; position: sticky; left: 0; z-index: 5; text-transform: uppercase; letter-spacing: 0.5px;"></th>
                    ${origIds.map((origId, idx) => {
                      const variant = currentVariants[idx];
                      const allVariants = modalCompareState.products[origId];
                      const variantLabel = buildVariantLabel(variant);
                      return `
                        <th style="padding: 16px; text-align: center; background: #ffffff; border-bottom: 2px solid #e5e7eb; min-width: 220px; vertical-align: top;">
                          <img src="${escapeHtml(shopifyImageUrl(variant.image_url || '', 200))}" alt="" style="width: 100px; height: 100px; object-fit: contain; margin: 0 auto 12px; border-radius: 8px; background: white; padding: 8px; border: 1px solid #e5e7eb;">
                          <div style="color: #1a1a1a; line-height: 1.4; font-weight: 600; font-size: 14px; margin-bottom: 10px;">${escapeHtml(variant.title || '')}</div>
                          ${allVariants.length > 1
                            ? `<select onchange="changeCompareVariant('${origId}', this.value)" aria-label="Select variant" style="width: 100%; max-width: 200px; padding: 6px 10px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 12px; color: #1a1a1a; background: white; cursor: pointer; margin-bottom: 10px;">
                                ${allVariants.map(v => `<option value="${v.id}" ${v.id === variant.id ? 'selected' : ''}>${escapeHtml(buildVariantLabel(v))}</option>`).join('')}
                              </select>`
                            : `<div style="font-size: 12px; color: #6b7280; margin-bottom: 10px;">${escapeHtml(variantLabel)}</div>`}
                          <div style="font-size: 18px; font-weight: 700; color: #1a1a1a;">$${formatPrice(variant.price)}</div>
                        </th>
                      `;
                    }).join('')}
                  </tr>
                </thead>
                <tbody>
                  ${buildComparisonRows(currentVariants)}
                </tbody>
              </table>
            </div>
            <div style="padding: 24px; background: #fafafa; border-top: 1px solid #e5e7eb; display: flex; justify-content: space-between; align-items: center; border-radius: 0 0 12px 12px;">
              <button onclick="clearCompare(); closeCompareModal();" style="padding: 10px 18px; background: white; border: 1px solid #d1d5db; color: #6b7280; font-size: 14px; font-weight: 500; cursor: pointer; border-radius: 6px; transition: all 0.2s;"
                      onmouseover="this.style.background='#f9fafb'; this.style.borderColor='#9ca3af';"
                      onmouseout="this.style.background='white'; this.style.borderColor='#d1d5db';">
                Clear All & Close
              </button>
              <button onclick="closeCompareModal()" style="padding: 10px 24px; background: #1a1a1a; color: white; border: none; font-size: 14px; font-weight: 600; cursor: pointer; border-radius: 6px; transition: all 0.2s;"
                      onmouseover="this.style.opacity='0.85';"
                      onmouseout="this.style.opacity='1';">
                Close
              </button>
            </div>
          </div>
        </div>
      `;
    }
  
    function buildComparisonRows(products) {
      const SPEC_SEP = '␟'; // composite key separator: "<group>␟<label>" -> looked up in comparison_specs
      const getValue = (product, key) => {
        if (product == null) return undefined;
        // Unified specs: composite "group␟label" keys read from the comparison_specs array
        if (key.indexOf(SPEC_SEP) !== -1) {
          const sep = key.indexOf(SPEC_SEP);
          const g = key.slice(0, sep), l = key.slice(sep + 1);
          const rows = Array.isArray(product.comparison_specs) ? product.comparison_specs : [];
          const hit = rows.find(r => r && r.group === g && r.label === l);
          return hit ? hit.value : undefined;
        }
        // Top-level identity fields (vendor, sku)
        if (Object.prototype.hasOwnProperty.call(product, key)) return product[key];
        return undefined;
      };
      const isPresent = (v) => v !== undefined && v !== null && v !== '';
      const formatVal = (v, p, key) => {
        if (key === 'sku' && !isPresent(v) && p) return p.variant_sku || 'N/A';
        if (v === true || v === 'true') return 'Yes';
        if (v === false || v === 'false') return 'No';
        if (Array.isArray(v)) return v.join(', ') || 'N/A';
        if (!isPresent(v)) return 'N/A';
        return String(v);
      };

      // Build comparison sections dynamically from each product's unified spec rows.
      // Top section = identity fields; then one section per spec group (first-seen order),
      // rows = union of labels within each group (first-seen order). Keys are "group␟label".
      const groupOrder = [];
      const groupLabels = {};
      products.forEach(p => {
        const rows = (p && Array.isArray(p.comparison_specs)) ? p.comparison_specs : [];
        for (const r of rows) {
          if (!r || !isPresent(r.value)) continue;
          if (!groupLabels[r.group]) { groupLabels[r.group] = []; groupOrder.push(r.group); }
          if (!groupLabels[r.group].includes(r.label)) groupLabels[r.group].push(r.label);
        }
      });
      const sections = [
        { label: null, rows: [ { label: 'Brand', key: 'vendor' }, { label: 'SKU', key: 'sku' } ] },
        ...groupOrder.map(g => ({ label: g, rows: groupLabels[g].map(l => ({ label: l, key: g + SPEC_SEP + l })) }))
      ];

      let html = '';
      let rowIdx = 0;
      const colCount = products.length + 1;

      for (const section of sections) {
        // Filter rows that have at least one non-empty value across products
        const visibleRows = section.rows.filter(row =>
          products.some(p => isPresent(getValue(p, row.key)))
        );
        if (visibleRows.length === 0) continue;

        if (section.label) {
          html += `<tr><td colspan="${colCount}" style="padding: 14px 16px; background: #1a1a1a; color: white; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; position: sticky; left: 0;">${section.label}</td></tr>`;
        }

        for (const row of visibleRows) {
          const bg = rowIdx % 2 === 0 ? '#fafafa' : 'white';
          html += `
            <tr>
              <td style="padding: 20px 16px; font-size: 13px; font-weight: 600; color: #6b7280; background: ${bg}; border-bottom: 1px solid #e7e7e7; position: sticky; left: 0; z-index: 5; text-transform: uppercase; letter-spacing: 0.5px;">${row.label}</td>
              ${products.map(p => {
                const val = getValue(p, row.key);
                return `<td style="padding: 20px 16px; text-align: center; font-size: 14px; color: #1a1a1a; background: ${bg}; border-bottom: 1px solid #e7e7e7; font-weight: 500;">${escapeHtml(formatVal(val, p, row.key))}</td>`;
              }).join('')}
            </tr>
          `;
          rowIdx++;
        }
      }

      return html;
    }
  
    window.closeCompareModal = function() {
      const modal = document.getElementById('compare-modal');
      if (modal) modal.remove();
      document.body.style.overflow = '';
    };
  
    // Elevar dl_select_item — event delegation on product card clicks
    els.resultsGrid.addEventListener('click', function(e) {
      const link = e.target.closest('a[data-elevar-product-id]');
      if (!link) return;
      const productId = link.dataset.elevarProductId;
      const card = link.closest('.product-card');
      const cardIndex = card ? Array.from(els.resultsGrid.children).indexOf(card) : 0;
      const product = allProducts.find(p => p.id === productId);
      if (product) fireElevarSelectItem(product, cardIndex);
    });
  
    // Initialize compare bar on load
    if (compareProducts.size > 0) {
      updateCompareBar();
    }
  
    DEBUG && console.log('✅ Meilisearch collection initialized');
  })();
  });
  